import React, { useRef, useState, useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { debounce } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import WavesIcon from "@mui/icons-material/Waves";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Typography,
  Container,
  Button,
  Grid,
  IconButton,
  TextField,
  InputAdornment,
  Backdrop,
  CircularProgress,
  Slider,
  Popover,
  Tooltip,
  Menu,
  MenuItem,
  // ListItemIcon,
  // ListItemText,
  ToggleButtonGroup,
  ToggleButton,
  Switch,
  Stack,
  Link,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  Stage,
  Layer,
  Image as KonvaImage,
  // Label,
  // Tag,
  Text,
  TextPath,
  Group,
  Transformer,
  Rect,
} from "react-konva";
import SidebarMenu from "components/SidebarMenu/SidebarMenu";
import PreviewModal from "components/PreviewModal/PreviewModal";

import { ChromePicker } from "react-color";
import CropModal from "components/CropModal/CropModal";
import LayerNavigator from "components/LayerNavigator/LayerNavigator";
import {
  ContentCut,
  Crop,
  Flip,
  Delete,
  // Close,
  Undo,
  Redo,
  ZoomIn,
  ZoomOut,
  Refresh,
  Visibility,
  InfoOutlined,
  ArrowUpward,
  ArrowForward,
  ArrowDownward,
  ArrowBack,
  FileCopy,
  DeleteOutline,
} from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import DragDropZoneMulti from "components/DragDropZoneMulti/DragDropZoneMulti";
// import { removeBackground } from "modern-rembg";
import {
  fetchCategoryOptions,
  fetchProductsByCategory,
  fetchStickers,
  fetchFonts,
  uploadTempImage,
  fetchTemplateById,
  uploadMultipleDesignAttachments,
  downloadByEncryptedId,
  downloadJsonByEncryptedId,
  fetchPreviewCombinedImage,
  callRemoveBgApi,
  fetchTempDesignFromUrl,
} from "api/publicService";
import { getImageUrl } from "api/AttachmentAPI";
import { fetchTemplateCreate, fetchTemplateUpdate } from "api/templateService";
import { verifyUserLoggedIn } from "api/api_register2FA";
import useFetchLayers from "components/useFetchLayers/useFetchLayers";
import Konva from "konva";
import { create as createDesignAPI, update as updateDesignAPI } from "api/CustomerDesignService";
import SharePopup from "./SharePopup";
import { renderAllSidesToFiles } from "./renderAllSidesToFiles";

function hexToRGBA(hex) {
  if (typeof hex !== "string") return { r: 0, g: 0, b: 0 };

  const cleaned = hex.trim().replace("#", "");
  if (!/^[0-9A-Fa-f]{6}$/.test(cleaned)) return { r: 0, g: 0, b: 0 };

  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);

  return { r, g, b };
}

function AlignDropdown({ onChange, currentAlign }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (align) => {
    onChange(align);
    handleClose();
  };

  const iconMap = {
    left: <FormatAlignLeftIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />,
    center: <FormatAlignCenterIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />,
    right: <FormatAlignRightIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />,
  };

  return (
    <>
      <Tooltip title="Căn lề">
        <IconButton onClick={handleClick} size="small" sx={{ p: { xs: 0.5, sm: 1 } }}>
          {iconMap[currentAlign] || <FormatAlignLeftIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />}
          <ArrowDropDownIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {/* <MenuItem onClick={() => handleSelect("left")}>
          <ListItemIcon>
            <FormatAlignLeftIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Căn trái" />
        </MenuItem>
        <MenuItem onClick={() => handleSelect("center")}>
          <ListItemIcon>
            <FormatAlignCenterIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Căn giữa" />
        </MenuItem>
        <MenuItem onClick={() => handleSelect("right")}>
          <ListItemIcon>
            <FormatAlignRightIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Căn phải" />
        </MenuItem> */}
        <MenuItem
          onClick={() => handleSelect("left")}
          sx={{ justifyContent: "center", minWidth: "40px" }}
        >
          <FormatAlignLeftIcon sx={{ fontSize: { xs: 14, sm: 18 } }} fontSize="small" />
        </MenuItem>
        <MenuItem
          onClick={() => handleSelect("center")}
          sx={{ justifyContent: "center", minWidth: "40px" }}
        >
          <FormatAlignCenterIcon sx={{ fontSize: { xs: 14, sm: 18 } }} fontSize="small" />
        </MenuItem>
        <MenuItem
          onClick={() => handleSelect("right")}
          sx={{ justifyContent: "center", minWidth: "40px" }}
        >
          <FormatAlignRightIcon sx={{ fontSize: { xs: 14, sm: 18 } }} fontSize="small" />
        </MenuItem>
      </Menu>
    </>
  );
}
AlignDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentAlign: PropTypes.oneOf(["left", "center", "right"]),
};
AlignDropdown.defaultProps = {
  currentAlign: "left",
};

function DesignToolSection() {
  const navigate = useNavigate();
  const stageRef = useRef();
  const transformerRef = useRef();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [highlightImage, setHighlightImage] = useState(null);
  const [selectedTool, setSelectedTool] = useState("product");
  const [texts, setTexts] = useState([]);
  const [selectedTextId, setSelectedTextId] = useState(null);
  const [overlayImageFront, setOverlayImageFront] = useState(null);
  const [overlayFrontSize, setOverlayFrontSize] = useState({ width: 0, height: 0 });
  const isMobile2 = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)");
  const canvasSize = useMemo(() => {
    if (isMobile2) return 360;
    if (isTablet) return 480;
    return 750;
  }, [isMobile2, isTablet]);

  const canvasWidth = canvasSize;
  const canvasHeight = useMemo(() => {
    if (isMobile2) return canvasSize;
    if (isTablet) return canvasSize;
    return canvasSize + 50;
  }, [isMobile2, isTablet]);

  const logoWidth = useMemo(() => {
    if (isMobile2) return 60;
    if (isTablet) return 80;
    return 135;
  }, [isMobile2, isTablet]);
  const logoHeight = useMemo(() => {
    if (isMobile2) return 35;
    if (isTablet) return 45;
    return 80;
  }, [isMobile2, isTablet]);

  const [imageSize, setImageSize] = useState({ width: 550, height: 670 });
  const [curveAnchorEl, setCurveAnchorEl] = useState(null);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [colorPickerPosition, setColorPickerPosition] = useState({ top: 0, left: 0 });
  const colorPickerRef = useRef(null);
  const colorButtonRef = useRef(null);
  const defaultColorButtonRef = useRef(null);
  const defaultColorPickerRef = useRef(null);
  const canvasColorPickerRef = useRef(null);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);
  const canvasContainerRef = useRef(null);
  const [textInput, setTextInput] = useState("");
  const [showDefaultColorPicker, setShowDefaultColorPicker] = useState(false);
  const [defaultColorPickerPosition, setDefaultColorPickerPosition] = useState({ top: 0, left: 0 });
  const [defaultTextColor, setDefaultTextColor] = useState("#000000"); // dùng khi thêm text mới
  const [textColor, setTextColor] = useState("#000000"); // chỉ dùng khi đổi màu text đang chọn
  const [dropzoneFiles, setDropzoneFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const uploadInputRef = useRef();
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategoryValue, setSelectedCategoryValue] = useState(null);
  const [productList, setProductList] = useState([]);
  const [imageMap, setImageMap] = useState({});
  const imageMapRef = useRef(imageMap);
  const [templatePage, setTemplatePage] = useState(0);
  const [templateTotal, setTemplateTotal] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [layerOptions, setLayerOptions] = useState([]);
  const { fetchLayersByTemplateId } = useFetchLayers();
  const [overlayLayers, setOverlayLayers] = useState([]);
  const [currentAttachType, setCurrentAttachType] = useState(null);
  const isMannequinSelected = currentAttachType === 4;
  const overlayKonvaRefs = useRef([]); // mảng ref của từng overlay layer
  const [layerColorMap, setLayerColorMap] = useState({});
  const [canvasStates, setCanvasStates] = useState({});
  const [selectedLayerId, setSelectedLayerId] = useState(null);
  const highlightImageRef = useRef(null);
  const filteredLayerOptions = currentAttachType
    ? layerOptions.filter((l) => l.layerType === currentAttachType)
    : [];
  const [undoStacks, setUndoStacks] = useState({}); // key = `${attachType}-${layerId}`
  const [redoStacks, setRedoStacks] = useState({});

  const [searchText, setSearchText] = useState("");
  const [stickerList, setStickerList] = useState([]);
  const [stickerTotal, setStickerTotal] = useState(0);
  const [stickerPage, setStickerPage] = useState(0);
  const [stickers, setStickers] = useState([]);
  const [selectedStickerId, setSelectedStickerId] = useState(null);
  const [fontList, setFontList] = useState([]);
  const MAX_UNDO = 30;
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const location = useLocation();
  const [isRestoringEdit, setIsRestoringEdit] = useState(false);
  const [designToEdit, setDesignToEdit] = useState(location.state?.designToEdit || null);
  const [designToPending, setDesignToPending] = useState(null);
  const [shareLink, setShareLink] = useState(null);
  const [showShareDialog, setShowShareDialog] = useState(false);
  const [layerReady, setLayerReady] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);
  const baseZoom = Math.min(canvasWidth / imageSize.width, canvasHeight / imageSize.height); // ~1.09
  const [zoom, setZoom] = useState(baseZoom);
  const [zoomAnchorEl, setZoomAnchorEl] = useState(null);
  const [tempZoom, setTempZoom] = useState(zoom);
  const [isGeneratingOverlay, setIsGeneratingOverlay] = useState(false);
  const [overlayFrontOrder] = useState(1);
  const [isRemovingBg, setIsRemovingBg] = useState(false);
  const textRefs = useRef({});
  const [watermarkImage, setWatermarkImage] = useState(null);
  const [SampleLogo, setSampleLogo] = useState(null);
  const [showWatermark, setShowWatermark] = useState(true); // hiển thị watermark chỉ khi đang xem
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [, setActionCount] = useState(0);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const ACTION_LIMIT = 10;
  const [isResetting, setIsResetting] = useState(false);
  const [pendingUndoSnapshot, setPendingUndoSnapshot] = useState(null);
  const layerColorMapRef = useRef(layerColorMap);
  // const STAGE_WIDTH = stageRef.current?.width() || 600;
  // const STAGE_HEIGHT = stageRef.current?.height() || 600;
  const stickerRefs = useRef({});
  const uploadImageRefs = useRef({});
  async function cropImageFile(
    file,
    padding = 20,
    maintainAspectRatio = false,
    targetWidth = 1000,
    targetHeight = 1400
  ) {
    return new Promise((resolve) => {
      const img = new Image();

      img.onload = () => {
        const imgWidth = img.width;
        const imgHeight = img.height;

        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = imgWidth;
        tempCanvas.height = imgHeight;
        const tempCtx = tempCanvas.getContext("2d");
        tempCtx.drawImage(img, 0, 0);

        const imageData = tempCtx.getImageData(0, 0, imgWidth, imgHeight);
        const { data } = imageData;

        // Tìm bounding box và tâm trọng số
        let minX = imgWidth;
        let maxX = 0;
        let minY = imgHeight;
        let maxY = 0;
        let sumX = 0;
        let sumY = 0;
        let count = 0;

        for (let y = 0; y < imgHeight; y += 1) {
          for (let x = 0; x < imgWidth; x += 1) {
            const alpha = data[(y * imgWidth + x) * 4 + 3];
            if (alpha > 10) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
              sumX += x;
              sumY += y;
              count += 1;
            }
          }
        }

        if (count === 0) {
          resolve(file);
          return;
        }

        const centerX = sumX / count;
        const centerY = sumY / count;

        // Tính kích thước bounding box
        let contentWidth = maxX - minX;
        let contentHeight = maxY - minY;

        // Chuẩn hóa kích thước vùng cắt
        let cropWidth;
        let cropHeight;
        if (maintainAspectRatio) {
          cropWidth = targetWidth;
          cropHeight = targetHeight;
        } else {
          // Nếu không giữ tỷ lệ, sử dụng kích thước bounding box nhưng giới hạn tối đa
          cropWidth = Math.min(
            Math.max(contentWidth + 2 * padding, targetWidth * 0.5),
            targetWidth
          );
          cropHeight = Math.min(
            Math.max(contentHeight + 2 * padding, targetHeight * 0.5),
            targetHeight
          );
        }

        // Điều chỉnh để giữ tỷ lệ nếu maintainAspectRatio = true
        if (maintainAspectRatio && contentWidth / contentHeight !== targetWidth / targetHeight) {
          const targetRatio = targetWidth / targetHeight;
          if (contentWidth / contentHeight > targetRatio) {
            contentHeight = contentWidth / targetRatio;
          } else {
            contentWidth = contentHeight * targetRatio;
          }
        }

        // Tính lại vùng cắt dựa trên tâm trọng số
        const halfCropWidth = Math.floor(cropWidth / 2);
        const halfCropHeight = Math.floor(cropHeight / 2);

        // Đảm bảo vùng cắt nằm trong giới hạn ảnh và tập trung vào tâm trọng số
        const newMinX = Math.max(0, Math.round(centerX - halfCropWidth));
        const newMinY = Math.max(0, Math.round(centerY - halfCropHeight));
        const newMaxX = Math.min(imgWidth, newMinX + cropWidth);
        const newMaxY = Math.min(imgHeight, newMinY + cropHeight);

        // Cập nhật lại cropWidth và cropHeight nếu bị giới hạn bởi kích thước ảnh
        cropWidth = newMaxX - newMinX;
        cropHeight = newMaxY - newMinY;

        // Tạo canvas cuối cùng
        const finalCanvas = document.createElement("canvas");
        finalCanvas.width = maintainAspectRatio ? targetWidth : cropWidth;
        finalCanvas.height = maintainAspectRatio ? targetHeight : cropHeight;

        const ctx = finalCanvas.getContext("2d");

        // Nếu maintainAspectRatio = true, căn giữa vùng cắt trong canvas
        const drawX = maintainAspectRatio ? Math.round((targetWidth - cropWidth) / 2) : 0;
        const drawY = maintainAspectRatio ? Math.round((targetHeight - cropHeight) / 2) : 0;

        ctx.drawImage(
          img,
          newMinX,
          newMinY,
          cropWidth,
          cropHeight,
          drawX,
          drawY,
          cropWidth,
          cropHeight
        );

        finalCanvas.toBlob((blob) => {
          const croppedFile = new File([blob], file.name, { type: "image/png" });
          resolve(croppedFile);
        }, "image/png");
      };

      img.crossOrigin = "Anonymous";
      img.src = URL.createObjectURL(file);
    });
  }

  useEffect(() => {
    layerColorMapRef.current = layerColorMap; // Đồng bộ layerColorMap với ref
  }, [layerColorMap]);

  useEffect(() => {
    const savedUrl = sessionStorage.getItem("designToPendingAfterLogin");

    if (savedUrl && savedUrl !== "undefined" && savedUrl !== "null") {
      fetchTempDesignFromUrl(savedUrl)
        .then((json) => {
          setDesignToPending(json);
          sessionStorage.removeItem("designToPendingAfterLogin"); // optional
        })
        .catch((err) => {
          console.warn("❌ Không thể load thiết kế tạm:", err);
          setDesignToPending(null);
        });
    }
  }, []);

  // Kiểm tra đăng nhập khi mở tool
  useEffect(() => {
    const checkUserLogin = async () => {
      const result = await verifyUserLoggedIn();
      setIsUserLoggedIn(result);
    };
    checkUserLogin();
  }, []);

  // Tăng số thao tác, hiển thị popup nếu cần
  const increaseActionCount = () => {
    if (isUserLoggedIn) return;

    setActionCount((prev) => {
      const newCount = prev + 1;
      if (newCount >= ACTION_LIMIT) {
        setShowLoginPrompt(true);
        return 0;
      }
      return newCount;
    });
  };

  // Hiển thị popup
  useEffect(() => {
    if (!showLoginPrompt) return;

    const handleLoginPrompt = async () => {
      const result = await Swal.fire({
        title: "Bạn cần đăng nhập/đăng ký để được trải nghiệm tốt hơn",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Đăng nhập",
        cancelButtonText: "Tiếp tục sau",
        showCloseButton: true,
      });

      if (result.isConfirmed) {
        const canvasStatesToSave = {};
        Object.entries(canvasStates).forEach(([key, state]) => {
          canvasStatesToSave[key] = {
            texts: state.texts || [],
            uploadedImages: (state.uploadedImages || []).map((img) => ({
              ...img,
              src: img.image?.src,
              image: undefined,
              attachType: img.attachType,
              layerKey: img.layerKey,
            })),
            stickers: (state.stickers || []).map((s) => ({
              ...s,
              src: s.image?.src,
              image: undefined,
              attachType: s.attachType,
              layerKey: s.layerKey,
            })),
            layerColorMap: state.layerColorMap || {},
          };
        });

        const tempDesignData = {
          canvasStates: canvasStatesToSave,
          selectedProduct,
          currentAttachType,
          selectedLayerId,
          templateId: selectedProduct?.templateId,
        };

        try {
          const jsonBlob = new Blob([JSON.stringify(tempDesignData)], {
            type: "application/json",
          });
          const jsonFile = new File([jsonBlob], "tempDesign.json", {
            type: "application/json",
          });

          const { fullUrl } = await uploadTempImage(jsonFile);
          const encodedId = fullUrl.split("/").pop();
          localStorage.setItem("tempDesignBeforeLogin", encodedId);
        } catch (err) {
          console.error("❌ Upload tempDesign thất bại:", err);
        }

        navigate("/authentication/sign-in");
      } else {
        setShowLoginPrompt(false);
      }
    };

    handleLoginPrompt(); // ✅ gọi async function bên trong useEffect
  }, [showLoginPrompt]);

  useEffect(() => {
    const img = new window.Image();
    img.src = "/watermark/zumi watermark.png";
    img.onload = () => setWatermarkImage(img);
  }, []);

  useEffect(() => {
    const img = new window.Image();
    img.src = "/watermark/LogoZumi.png";
    img.onload = () => setSampleLogo(img);
  }, []);

  useEffect(() => {
    imageMapRef.current = imageMap; // ✅ luôn sync mới nhất
  }, [imageMap]);

  useEffect(() => {
    const defaultFonts = [
      { fontFamily: "Arial", label: "Arial" },
      { fontFamily: "Times New Roman", label: "Times New Roman" },
      { fontFamily: "Courier New", label: "Courier New" },
      { fontFamily: "Tahoma", label: "Tahoma" },
    ];

    fetchFonts({ page: 0, size: 100 }).then((res) => {
      const apiFonts = res.datas || [];
      const allFonts = [...defaultFonts, ...apiFonts];

      // Lọc trùng theo fontFamily
      const uniqueFonts = Array.from(
        new Map(allFonts.map((font) => [font.fontFamily, font])).values()
      );
      setFontList(uniqueFonts);
    });
  }, []);

  const loadFontFromUrl = async (fontFamily, fontUrl) => {
    const fontFace = new FontFace(fontFamily, `url(${fontUrl})`);
    await fontFace.load();
    document.fonts.add(fontFace);
  };

  const pushUndoSnapshot = (customLayerColorMap = layerColorMap) => {
    if (!currentAttachType || !selectedLayerId) return;

    const layerKey = `${currentAttachType}-${selectedLayerId}`;
    const matchedLayers = layerOptions.filter(
      (l) => l.layerId === selectedLayerId && l.isColorChange === 1
    );

    const layerColorEntries = matchedLayers
      .map((layer) => {
        const key = `${layer.layerType}-${layer.layerId}`;
        // Lưu cả trường hợp không có màu (null hoặc undefined)
        return [key, customLayerColorMap[key] || null];
      })
      .filter(Boolean);

    const snapshot = {
      texts: texts.filter((t) => t.layerKey === layerKey && t.attachType === currentAttachType),
      uploadedImages: uploadedImages
        .filter((img) => img.layerKey === layerKey && img.attachType === currentAttachType)
        .map((img) => ({ ...img, src: img.image?.src, image: undefined })),
      stickers: stickers
        .filter((s) => s.layerKey === layerKey && s.attachType === currentAttachType)
        .map((s) => ({ ...s, src: s.image?.src, image: undefined })),
      layerColorMap: Object.fromEntries(layerColorEntries),
    };

    const hasContent =
      snapshot.texts.length ||
      snapshot.uploadedImages.length ||
      snapshot.stickers.length ||
      layerColorEntries.length;
    if (!hasContent) return;

    setUndoStacks((prev) => {
      const stack = prev[layerKey] || [];
      const last = stack[stack.length - 1];
      if (JSON.stringify(last) === JSON.stringify(snapshot)) return prev;

      const newStack = [...stack, snapshot].slice(-MAX_UNDO);
      return { ...prev, [layerKey]: newStack };
    });

    setRedoStacks((prev) => ({ ...prev, [layerKey]: [] }));
  };
  const calculateTextWidth = (text, fontSize, fontFamily) => {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.font = `${fontSize}px ${fontFamily || "Arial"}`;

    if (fontFamily && !document.fonts.check(`1px ${fontFamily}`)) {
      console.warn(`Font ${fontFamily} chưa được tải, fallback về Arial`);
      ctx.font = `${fontSize}px Arial`;
    }

    const lines = text.split("\n");
    const widths = lines.map((line) => ctx.measureText(line).width);
    const maxWidth = Math.max(...widths);

    return maxWidth; // Padding tối thiểu
  };

  const calculateCurvedTextBounds = (text, fontSize, fontFamily, radius, lineSpacing) => {
    const lines = text.split("\n");
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.font = `${fontSize}px ${fontFamily || "Arial"}`;

    let maxWidth = 0;
    let totalHeight = 0;

    lines.forEach((line, lineIndex) => {
      const textMetrics = ctx.measureText(line);
      const textWidth = textMetrics.width;
      const r = (Number.isFinite(radius) ? radius : 150) + lineIndex * (lineSpacing || 40);

      // Ước lượng chiều rộng văn bản trên cung tròn
      const arcWidth = Math.min(textWidth, r * Math.PI); // Giới hạn chiều rộng tối đa
      maxWidth = Math.max(maxWidth, Number.isFinite(arcWidth) ? arcWidth : textWidth);
      totalHeight = (lineIndex + 1) * (lineSpacing || 40);
    });

    totalHeight = Math.max(totalHeight, fontSize); // Đảm bảo chiều cao tối thiểu

    // Tính tâm Y chính xác hơn
    const centerY = lines.length > 1 ? totalHeight / 2 : fontSize / 2;

    return {
      width: Number.isFinite(maxWidth) ? maxWidth + 20 : 100, // Thêm padding
      height: Number.isFinite(totalHeight) ? totalHeight + 20 : fontSize + 20, // Thêm padding
      centerX: 0, // Tâm X của Group
      centerY, // Tâm Y được điều chỉnh
    };
  };

  const createCurvedTextDragBoundFunc = (text) => (pos) => {
    const { width, height } = calculateCurvedTextBounds(
      text.text,
      text.fontSize,
      text.fontFamily,
      text.arcRadius,
      text.lineSpacing || 40
    );

    const minX = width / 2;
    const maxX = canvasWidth - width / 2;
    const minY = height / 2;
    const maxY = canvasHeight - height / 2;

    return {
      x: Math.max(minX, Math.min(maxX, pos.x)),
      y: Math.max(minY, Math.min(maxY, pos.y)),
    };
  };

  const adjustCurvedTextToFit = (textObj, canvasWidthF, canvasHeightF) => {
    const { text, fontSize, fontFamily, arcRadius, lineSpacing = 40 } = textObj;
    let adjustedFontSize = fontSize;
    let adjustedRadius = arcRadius;
    let iterationCount = 0;
    const maxIterations = 100; // Giới hạn số lần lặp

    let bounds = calculateCurvedTextBounds(
      text,
      adjustedFontSize,
      fontFamily,
      adjustedRadius,
      lineSpacing
    );

    const maxWidth = canvasWidthF * 0.9;
    const maxHeight = canvasHeightF * 0.9;

    while (bounds.width > maxWidth || bounds.height > maxHeight) {
      if (iterationCount >= maxIterations) {
        console.warn("Max iterations reached in adjustCurvedTextToFit");
        break;
      }

      if (bounds.width > maxWidth) {
        adjustedRadius += 10;
      }
      if (bounds.height > maxHeight) {
        adjustedFontSize = Math.max(adjustedFontSize - 1, 10);
      }

      bounds = calculateCurvedTextBounds(
        text,
        adjustedFontSize,
        fontFamily,
        adjustedRadius,
        lineSpacing
      );

      iterationCount += 1;
    }

    adjustedRadius = Math.max(adjustedRadius, 100 * (adjustedFontSize / 20));

    return { adjustedFontSize, adjustedRadius };
  };

  const handleChangeAlign = (align) => {
    setTexts((prev) => prev.map((t) => (t.id === selectedTextId ? { ...t, align } : t)));
  };

  const renderCurvedMultilineText = ({
    text = "",
    cx = 0,
    cy = 0,
    radius = 150,
    lineSpacing = 40,
    fontSize = 20,
    fill = "black",
    fontFamily = "Arial",
    idPrefix = "",
    arcDirection = "down",
    rotation = 0,
    providedWidth, // Thêm từ văn bản ngang
    providedHeight, // Thêm từ văn bản ngang
  }) => {
    const { adjustedFontSize, adjustedRadius } = adjustCurvedTextToFit(
      { text, fontSize, fontFamily, arcRadius: radius, lineSpacing },
      canvasWidth / zoom,
      canvasHeight / zoom
    );

    const lines = text.split("\n");
    const result = [];

    // Tính kích thước và tâm của văn bản cong
    const {
      width: groupWidth,
      height: groupHeight,
      centerY,
    } = calculateCurvedTextBounds(text, adjustedFontSize, fontFamily, adjustedRadius, lineSpacing);

    // Tính offset để căn giữa tâm của văn bản cong với văn bản ngang
    const xOffset = providedWidth ? (groupWidth - providedWidth) / 2 : 0;
    const yOffset = arcDirection === "down" ? -centerY : centerY;

    // Điều chỉnh vị trí x, y để giữ tâm
    const adjustedCx = cx + xOffset;
    const adjustedCy = cy + (providedHeight ? (groupHeight - providedHeight) / 2 : 0);

    lines.forEach((line, lineIndex) => {
      const r = adjustedRadius + lineIndex * lineSpacing;
      const pathData =
        arcDirection === "down"
          ? `M ${-r} 0 A ${r} ${r} 0 0 1 ${r} 0`
          : `M ${-r} 0 A ${r} ${r} 0 0 0 ${r} 0`;

      result.push(
        <TextPath
          key={`${idPrefix}-line-${lineIndex}`}
          x={0}
          y={lineIndex * lineSpacing + yOffset}
          text={line}
          fontSize={adjustedFontSize}
          fill={fill}
          fontFamily={fontFamily}
          data={pathData}
          kerningFunc={() => 0}
        />
      );
    });

    return (
      <Group
        x={adjustedCx}
        y={adjustedCy}
        draggable
        rotation={rotation}
        dragBoundFunc={createCurvedTextDragBoundFunc({
          text,
          fontSize: adjustedFontSize,
          fontFamily,
          arcRadius: adjustedRadius,
          lineSpacing,
        })}
        onClick={() => setSelectedTextId(idPrefix)}
        onTransformEnd={(e) => {
          const node = e.target;
          const scaleY = node.scaleY();
          const newRotation = node.rotation();

          node.scaleX(1);
          node.scaleY(1);

          const newFontSize = fontSize * scaleY;
          const newRadius = radius * scaleY;

          const { adjustedFontSize: newAdjustedFontSize, adjustedRadius: newAdjustedRadius } =
            adjustCurvedTextToFit(
              {
                text,
                fontSize: newFontSize,
                fontFamily,
                arcRadius: newRadius,
                lineSpacing,
              },
              canvasWidth,
              canvasHeight
            );

          const newBounds = calculateCurvedTextBounds(
            text,
            newAdjustedFontSize,
            fontFamily,
            newAdjustedRadius,
            lineSpacing
          );

          // Tính lại vị trí tâm
          const newX = node.x();
          const newY = node.y();

          setTexts((prev) =>
            prev.map((t) =>
              t.id === idPrefix
                ? {
                    ...t,
                    fontSize: newAdjustedFontSize,
                    arcRadius: newAdjustedRadius,
                    x: newX,
                    y: newY,
                    width: newBounds.width,
                    height: newBounds.height,
                    rotation: newRotation,
                  }
                : t
            )
          );

          node.x(newX);
          node.y(newY);
          node.getLayer()?.batchDraw();
        }}
        onDragEnd={(e) => {
          const node = e.target;
          const newX = node.x();
          const newY = node.y();

          setTexts((prev) =>
            prev.map((t) =>
              t.id === idPrefix
                ? {
                    ...t,
                    x: newX,
                    y: newY,
                    width: groupWidth,
                    height: groupHeight,
                  }
                : t
            )
          );

          node.getLayer()?.batchDraw();
        }}
      >
        <Rect
          x={-groupWidth / 2}
          y={-groupHeight / 2}
          width={groupWidth}
          height={groupHeight}
          fill="transparent"
          listening={false}
        />
        {result}
      </Group>
    );
  };

  const addTextToCanvas = useCallback(
    (text) => {
      const id = `text-${Date.now()}`;
      const fontSize = 20;
      const fontFamily = "Arial";
      const textWidth = calculateTextWidth(text, fontSize, fontFamily);
      const textHeight = fontSize;

      // Đặt tâm văn bản ở giữa canvas
      const x = canvasWidth / 2 - textWidth / 2;
      const y = canvasHeight / 2 - textHeight / 2;

      setTexts((prev) => [
        ...prev,
        {
          id,
          text,
          x,
          y,
          fontSize,
          fill: defaultTextColor,
          fontFamily,
          align: "left",
          offsetX: 0,
          offsetY: 0, // Không cần offsetY vì đã căn tâm
          width: Math.max(textWidth, 50), // Đảm bảo width không quá nhỏ
          height: textHeight,
          layerKey: `${currentAttachType}-${selectedLayerId}`,
          attachType: currentAttachType,
          isCurved: false,
          rotation: 0,
        },
      ]);
    },
    [defaultTextColor, currentAttachType, selectedLayerId, canvasWidth, canvasHeight]
  );

  useEffect(() => {
    if (selectedTool === "sticker") {
      fetchStickers({ page: 0, size: 10, searchText }).then((res) => {
        setStickerList(res.datas);
        setStickerTotal(res.totals);
        setStickerPage(0);
      });
    }
  }, [selectedTool, searchText]);

  useEffect(() => {
    if (selectedProduct?.templateId) {
      fetchLayersByTemplateId(selectedProduct.templateId, (layers) => {
        setLayerOptions(layers);
        setLayerReady(true); // ✅ thêm dòng này
      });
    } else {
      setLayerOptions([]);
      setLayerReady(false); // reset nếu không có sản phẩm
    }
  }, [selectedProduct, fetchLayersByTemplateId]);

  useEffect(() => {
    const fetchImages = async () => {
      const imageTasks = [];

      productList.forEach((item) => {
        item.attachments?.forEach((att) => {
          if (att.encryptedId && !imageMap[att.encryptedId]) {
            imageTasks.push(
              getImageUrl(`/api/public/attachments/downloadFile/${att.encryptedId}`).then(
                (url) => ({
                  encryptedId: att.encryptedId,
                  url,
                })
              )
            );
          }
        });
      });

      const results = await Promise.all(imageTasks);
      const newMap = {};
      results.forEach((res) => {
        if (res?.url) newMap[res.encryptedId] = res.url;
      });

      setImageMap((prev) => ({ ...prev, ...newMap }));
    };
    if (productList.length > 0) fetchImages();
  }, [productList]);

  useEffect(() => {
    const loadSelectedProductImages = async () => {
      if (!selectedProduct?.attachments) return;

      const imageTasks = selectedProduct.attachments
        .map((att) => att.encryptedId)
        .filter((id) => id && !imageMap[id])
        .map((id) =>
          getImageUrl(`/api/public/attachments/downloadFile/${id}`).then((url) => ({
            encryptedId: id,
            url,
          }))
        );

      const results = await Promise.all(imageTasks);
      const newMap = {};
      results.forEach((res) => {
        if (res?.url) newMap[res.encryptedId] = res.url;
      });

      setImageMap((prev) => ({ ...prev, ...newMap }));
    };

    loadSelectedProductImages();
  }, [selectedProduct]);

  useEffect(() => {
    const fetchStickerImages = async () => {
      const imageTasks = [];

      stickerList.forEach((sticker) => {
        const encryptedId = sticker?.attachment?.encryptedId;
        if (encryptedId && !imageMap[encryptedId]) {
          imageTasks.push(
            getImageUrl(`/api/public/attachments/downloadFile/${encryptedId}`).then((url) => ({
              encryptedId,
              url,
            }))
          );
        }
      });

      const results = await Promise.all(imageTasks);
      const newMap = {};
      results.forEach((res) => {
        if (res?.url) newMap[res.encryptedId] = res.url;
      });

      setImageMap((prev) => ({ ...prev, ...newMap }));
    };

    if (stickerList.length > 0) fetchStickerImages();
  }, [stickerList]);

  useEffect(() => {
    const fetchLayerImages = async () => {
      const imageTasks = [];

      layerOptions.forEach((layer) => {
        const encryptedId = layer?.attachment?.encryptedId;
        if (encryptedId && !imageMap[encryptedId]) {
          imageTasks.push(
            getImageUrl(`/api/public/attachments/downloadFile/${encryptedId}`).then((url) => ({
              encryptedId,
              url,
            }))
          );
        }
      });

      const results = await Promise.all(imageTasks);
      const newMap = {};
      results.forEach((res) => {
        if (res?.url) newMap[res.encryptedId] = res.url;
      });

      setImageMap((prev) => ({ ...prev, ...newMap }));
    };

    if (layerOptions.length > 0) {
      fetchLayerImages();
    }
  }, [layerOptions]);

  const loadMoreStickers = () => {
    const nextPage = stickerPage + 1;
    fetchStickers({ page: nextPage, size: 10, searchText }).then((res) => {
      setStickerList((prev) => [...prev, ...res.datas]);
      setStickerPage(nextPage);
    });
  };

  const loadMoreTemplates = () => {
    const nextPage = templatePage + 1;
    fetchProductsByCategory(selectedCategoryValue, nextPage, 10, searchText).then((res) => {
      setProductList((prev) => [...prev, ...res.datas]);
      setTemplatePage(nextPage);
    });
  };

  useEffect(() => {
    if (selectedCategoryValue) {
      setProductList([]); // reset khi đổi category
      setTemplatePage(0); // reset page
      fetchProductsByCategory(selectedCategoryValue, 0, 10, searchText).then((res) => {
        setProductList(res.datas);
        setTemplateTotal(res.totals);
      });
    }
  }, [selectedCategoryValue]);

  useEffect(() => {
    const stage = stageRef.current;
    const transformer = transformerRef.current;

    if (stage && transformer) {
      const selectedNode =
        (selectedTextId && stage.findOne(`#${selectedTextId}`)) ||
        (selectedImageId && stage.findOne(`#${selectedImageId}`)) ||
        (selectedStickerId && stage.findOne(`#${selectedStickerId}`));

      if (selectedNode) {
        transformer.nodes([selectedNode]);
        transformer.getLayer()?.batchDraw();
      } else {
        transformer.nodes([]);
        transformer.getLayer()?.batchDraw();
      }
    }
  }, [selectedTextId, selectedImageId, selectedStickerId, texts, uploadedImages, stickers]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        canvasColorPickerRef.current &&
        !canvasColorPickerRef.current.contains(event.target) &&
        colorButtonRef.current &&
        !colorButtonRef.current.contains(event.target)
      ) {
        setShowColorPicker(false);
      }

      if (
        defaultColorPickerRef.current &&
        !defaultColorPickerRef.current.contains(event.target) &&
        defaultColorButtonRef.current &&
        !defaultColorButtonRef.current.contains(event.target)
      ) {
        setShowDefaultColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedTextId) {
      const selected = texts.find((t) => t.id === selectedTextId);
      if (selected) setTextColor(selected.fill);
    }
  }, [selectedTextId]);

  useEffect(() => {
    const handleAddSticker = (e) => {
      const { id } = e.detail;

      setStickers((prev) => {
        const exists = prev.some((s) => s.id === id);
        if (exists) return prev; // ✅ Ngăn trùng
        return [...prev, { ...e.detail }];
      });
    };

    window.addEventListener("dropzone:add-image-to-canvas", handleAddSticker);
    return () => window.removeEventListener("dropzone:add-image-to-canvas", handleAddSticker);
  }, []);

  const getFrontImageUrl = (template) => {
    const front = template.attachments?.find((att) => att.attachType === 1);
    return front ? imageMap[front.encryptedId] : null;
  };
  const handleStageMouseDown = useCallback(
    (e) => {
      const stage = stageRef.current;
      const clickedOnEmpty = e.target === stage;
      const clickedOnTransformer = e.target.getParent()?.className === "Transformer";

      // Early exit for empty stage clicks to deselect everything
      if (clickedOnEmpty) {
        setSelectedTextId(null);
        setSelectedImageId(null);
        setSelectedStickerId(null);
        return;
      }

      // Allow Transformer interactions (e.g., dragging corners) without deselecting
      if (clickedOnTransformer) {
        return;
      }

      const clickedId = e.target.id();
      // Find clicked object with type-safe ID comparison
      const clickedSticker = stickers.find((s) => String(s.id) === clickedId);
      if (clickedSticker) {
        setSelectedStickerId(clickedSticker.id);
        setSelectedTextId(null);
        setSelectedImageId(null);
        return;
      }

      const clickedText = texts.find((t) => String(t.id) === clickedId);
      if (clickedText) {
        setSelectedTextId(clickedText.id);
        setSelectedImageId(null);
        setSelectedStickerId(null);
        return;
      }

      const clickedImage = uploadedImages.find((img) => String(img.id) === clickedId);
      if (clickedImage) {
        setSelectedImageId(clickedImage.id);
        setSelectedTextId(null);
        setSelectedStickerId(null);
        return;
      }

      // Fallback: deselect all if no valid object is found
      setSelectedTextId(null);
      setSelectedImageId(null);
      setSelectedStickerId(null);
    },
    [stickers, texts, uploadedImages]
  );
  // const handleStageMouseDown = useCallback(
  //   (e) => {
  //     const stage = stageRef.current;
  //     const clickedOnEmpty = e.target === stage;
  //     const clickedOnTransformer = e.target.getParent()?.className === "Transformer";
  //     const clickedSticker = stickers.find((s) => s.id === e.target.id());
  //     if (clickedSticker) {
  //       setSelectedStickerId(clickedSticker.id);
  //       setSelectedTextId(null);
  //       setSelectedImageId(null);
  //     }
  //     if (clickedOnEmpty) {
  //       setSelectedTextId(null);
  //       setSelectedImageId(null);
  //       setSelectedStickerId(null);
  //       return;
  //     }
  //     if (clickedOnTransformer) {
  //       return;
  //     }
  //     const clickedText = texts.find((t) => t.id === e.target.id());
  //     const clickedImage = uploadedImages.find((img) => img.id === e.target.id());
  //     if (clickedText) {
  //       setSelectedTextId(clickedText.id);
  //       setSelectedImageId(null);
  //       setSelectedStickerId(null);
  //     } else if (clickedImage) {
  //       setSelectedImageId(clickedImage.id);
  //       setSelectedTextId(null);
  //       setSelectedStickerId(null);
  //     } else {
  //       setSelectedTextId(null);
  //       setSelectedImageId(null);
  //       setSelectedStickerId(null);
  //     }
  //   },
  //   [stickers, texts, uploadedImages]
  // );

  const handleZoom = (newZoom) => {
    const stage = stageRef.current;
    if (!stage) return;

    const oldScale = stage.scaleX();
    const mousePointTo = {
      x: stage.width() / 2 / oldScale - stage.x() / oldScale,
      y: stage.height() / 2 / oldScale - stage.y() / oldScale,
    };

    stage.scale({ x: newZoom, y: newZoom });

    const newPos = {
      x: stage.width() / 2 - mousePointTo.x * newZoom,
      y: stage.height() / 2 - mousePointTo.y * newZoom,
    };

    stage.position(newPos);
    stage.batchDraw();
    setZoom(newZoom);
  };

  const MIN_ZOOM = 1.0;

  const handleZoomOut = () => {
    const step = 0.1;
    const newZoom = parseFloat((zoom - step).toFixed(2));
    if (newZoom < MIN_ZOOM) return;
    handleZoom(newZoom);
  };

  const handleZoomPopover = (event) => {
    setZoomAnchorEl(event.currentTarget); // ✅ để mở popover
    setTempZoom(zoom); // ✅ sync giá trị slider
  };

  const scaledImageSize = useMemo(() => {
    if (!imageSize?.width || !imageSize?.height) return { width: 0, height: 0 };

    const maxSize = canvasWidth; // Vuông
    const scale = Math.min(maxSize / imageSize.width, maxSize / imageSize.height, 1);
    return {
      width: imageSize.width * scale,
      height: imageSize.height * scale,
    };
  }, [canvasWidth, imageSize]);

  const scaledWatermarkSize = useMemo(() => {
    if (!watermarkImage?.width || !watermarkImage?.height) {
      return { width: 0, height: 0, x: 0, y: 0 };
    }

    const originalRatio = watermarkImage.width / watermarkImage.height; // = 1 nếu vuông
    const canvasRatio = canvasWidth / canvasHeight;

    let width;
    let height;

    if (canvasRatio > originalRatio) {
      // Canvas ngang hơn → scale theo chiều CAO nhưng mở rộng chiều RỘNG để phủ
      height = canvasHeight;
      width = height * originalRatio;

      // Mở rộng width để đảm bảo phủ hết chiều rộng
      if (width < canvasWidth) {
        const scale = canvasWidth / width;
        width *= scale;
        height *= scale;
      }
    } else {
      // Canvas cao hơn → scale theo chiều RỘNG nhưng mở rộng chiều CAO để phủ
      width = canvasWidth;
      height = width / originalRatio;

      if (height < canvasHeight) {
        const scale = canvasHeight / height;
        width *= scale;
        height *= scale;
      }
    }

    const x = (canvasWidth - width) / 2;
    const y = (canvasHeight - height) / 2;

    return { width, height, x, y };
  }, [canvasWidth, canvasHeight, watermarkImage]);

  const getBaseZoomDataURL = useCallback(
    (pixelRatio = 2, quality = 1) => {
      const stage = stageRef.current;
      if (!stage || !imageSize?.width || !imageSize?.height) return null;

      const originalScale = stage.scale();
      const originalPos = stage.position();

      // Reset zoom/position
      stage.scale({ x: 1, y: 1 });
      stage.position({ x: 0, y: 0 });

      // Crop phần ảnh thực (canh giữa)
      const x = (canvasWidth - imageSize.width) / 2;
      const y = (canvasHeight - imageSize.height) / 2;

      const dataUrl = stage.toDataURL({
        x,
        y,
        width: imageSize.width,
        height: imageSize.height,
        pixelRatio,
        quality,
      });

      // Khôi phục lại scale/position ban đầu
      stage.scale(originalScale);
      stage.position(originalPos);

      return dataUrl;
    },
    [canvasWidth, canvasHeight, imageSize]
  );

  const moveSelected = (dx, dy) => {
    if (selectedTextId) {
      setTexts((prev) =>
        prev.map((t) => (t.id === selectedTextId ? { ...t, x: t.x + dx, y: t.y + dy } : t))
      );
    } else if (selectedImageId) {
      setUploadedImages((prev) =>
        prev.map((img) =>
          img.id === selectedImageId ? { ...img, x: img.x + dx, y: img.y + dy } : img
        )
      );
    } else if (selectedStickerId) {
      setStickers((prev) =>
        prev.map((img) =>
          img.id === selectedStickerId ? { ...img, x: img.x + dx, y: img.y + dy } : img
        )
      );
    } else {
      // ✅ Không có gì được chọn → dịch toàn bộ
      setTexts((prev) => prev.map((t) => ({ ...t, x: t.x + dx, y: t.y + dy })));
      setUploadedImages((prev) => prev.map((img) => ({ ...img, x: img.x + dx, y: img.y + dy })));
      setStickers((prev) => prev.map((img) => ({ ...img, x: img.x + dx, y: img.y + dy })));

      // Dịch luôn ảnh chính nếu muốn (tùy logic stage)
      if (stageRef.current) {
        const oldPos = stageRef.current.position();
        stageRef.current.position({ x: oldPos.x + dx, y: oldPos.y + dy });
        stageRef.current.batchDraw();
      }
    }
  };

  const duplicateSelected = () => {
    const layerKey = `${currentAttachType}-${selectedLayerId}`;
    const attachType = currentAttachType;
    if (selectedTextId) {
      const origin = texts.find((t) => t.id === selectedTextId);
      if (origin) {
        const newId = `text-${Date.now()}`;
        setTexts((prev) => [
          ...prev,
          { ...origin, id: newId, x: origin.x + 10, y: origin.y + 10, layerKey, attachType },
        ]);
      }
    } else if (selectedImageId) {
      const origin = uploadedImages.find((img) => img.id === selectedImageId);
      if (origin && origin.image) {
        const newId = `upload-${Date.now()}-${Math.random()}`;
        const newImage = new window.Image();
        newImage.src = origin.image.src;
        newImage.onload = () => {
          setUploadedImages((prev) => [
            ...prev,
            {
              ...origin,
              id: newId,
              x: origin.x + 10,
              y: origin.y + 10,
              image: newImage,
              layerKey,
              attachType,
            },
          ]);
        };
      }
    } else if (selectedStickerId) {
      const origin = stickers.find((img) => img.id === selectedStickerId);
      if (origin && origin.image) {
        const newId = `sticker-${Date.now()}-${Math.random()}`;
        const newImage = new window.Image();
        newImage.src = origin.image.src;
        newImage.onload = () => {
          setStickers((prev) => [
            ...prev,
            {
              ...origin,
              id: newId,
              x: origin.x + 10,
              y: origin.y + 10,
              image: newImage,
              layerKey,
              attachType,
            },
          ]);
        };
      }
    }
  };

  const deleteSelected = () => {
    pushUndoSnapshot(); // Lưu trạng thái trước khi xóa

    if (selectedTextId) {
      // Xóa văn bản khỏi state
      setTexts((prev) => prev.filter((t) => t.id !== selectedTextId));

      // Xóa node khỏi stage
      if (stageRef.current) {
        const node = stageRef.current.findOne(`#${selectedTextId}`);
        if (node) {
          node.destroy();
          stageRef.current.batchDraw();
        }
      }

      // Xóa tham chiếu trong textRefs
      if (textRefs.current[selectedTextId]) {
        delete textRefs.current[selectedTextId];
      }

      // Làm sạch Transformer
      if (transformerRef.current) {
        transformerRef.current.nodes([]);
        transformerRef.current.getLayer()?.batchDraw();
      }

      // Xóa selectedTextId
      setSelectedTextId(null);

      // Cập nhật canvasStates
      if (currentAttachType && selectedLayerId) {
        const key = `${currentAttachType}-${selectedLayerId}`;
        setCanvasStates((prev) => ({
          ...prev,
          [key]: {
            ...prev[key],
            texts: prev[key]?.texts?.filter((t) => t.id !== selectedTextId) || [],
          },
        }));
      }
    } else if (selectedImageId) {
      setUploadedImages((prev) => prev.filter((img) => img.id !== selectedImageId));
      setSelectedImageId(null);

      // Xóa node khỏi stage
      if (stageRef.current) {
        const node = stageRef.current.findOne(`#${selectedImageId}`);
        if (node) {
          node.destroy();
          stageRef.current.batchDraw();
        }
      }

      // Xóa tham chiếu trong uploadImageRefs
      if (uploadImageRefs.current[selectedImageId]) {
        delete uploadImageRefs.current[selectedImageId];
      }

      // Làm sạch Transformer
      if (transformerRef.current) {
        transformerRef.current.nodes([]);
        transformerRef.current.getLayer()?.batchDraw();
      }

      // Cập nhật canvasStates
      if (currentAttachType && selectedLayerId) {
        const key = `${currentAttachType}-${selectedLayerId}`;
        setCanvasStates((prev) => ({
          ...prev,
          [key]: {
            ...prev[key],
            uploadedImages:
              prev[key]?.uploadedImages?.filter((img) => img.id !== selectedImageId) || [],
          },
        }));
      }
    } else if (selectedStickerId) {
      setStickers((prev) => prev.filter((img) => img.id !== selectedStickerId));
      setSelectedStickerId(null);

      // Xóa node khỏi stage
      if (stageRef.current) {
        const node = stageRef.current.findOne(`#${selectedStickerId}`);
        if (node) {
          node.destroy();
          stageRef.current.batchDraw();
        }
      }

      // Xóa tham chiếu trong stickerRefs
      if (stickerRefs.current[selectedStickerId]) {
        delete stickerRefs.current[selectedStickerId];
      }

      // Làm sạch Transformer
      if (transformerRef.current) {
        transformerRef.current.nodes([]);
        transformerRef.current.getLayer()?.batchDraw();
      }

      // Cập nhật canvasStates
      if (currentAttachType && selectedLayerId) {
        const key = `${currentAttachType}-${selectedLayerId}`;
        setCanvasStates((prev) => ({
          ...prev,
          [key]: {
            ...prev[key],
            stickers: prev[key]?.stickers?.filter((s) => s.id !== selectedStickerId) || [],
          },
        }));
      }
    }
  };

  useEffect(() => {
    if (stageRef.current) {
      stageRef.current.batchDraw();
    }
  }, [texts, uploadedImages, stickers]);

  useEffect(() => {
    if (!currentAttachType) return;

    if (!currentAttachType || !selectedLayerId) return;
    const key = `${currentAttachType}-${selectedLayerId}`;

    setCanvasStates((prev) => ({
      ...prev,
      [key]: {
        texts: texts.map((t) => ({ ...t, rotation: t.rotation || 0 })),
        uploadedImages,
        stickers,
        layerColorMap,
      },
    }));
  }, [texts, uploadedImages, stickers, layerColorMap, currentAttachType]);

  const resetCanvasState = () => {
    setTexts([]);
    setUploadedImages([]);
    setOverlayLayers([]);
    setSelectedTextId(null);
    setSelectedImageId(null);
    setLayerColorMap({});
    setZoom(1); // ✅ Reset lại zoom

    if (stageRef.current) {
      stageRef.current.position({ x: 0, y: 0 });
      stageRef.current.batchDraw(); // cập nhật lại canvas
    }
  };

  const saveCurrentCanvasState = () => {
    if (isResetting || isRestoringEdit) return;
    if (!currentAttachType) return;

    if (!currentAttachType || !selectedLayerId) return;
    const key = `${currentAttachType}-${selectedLayerId}`;

    setCanvasStates((prev) => ({
      ...prev,
      [key]: {
        texts: texts.map((t) => ({ ...t })),
        uploadedImages,
        stickers,
        layerColorMap,
      },
    }));
  };

  const applyHighlightFilter = (layerId) => {
    const node = highlightImageRef.current;
    if (!node || !highlightImage) return;

    const key = `${currentAttachType}-${layerId}`;
    const hex = layerColorMap[key];
    if (!hex) return;

    const rgba = hexToRGBA(hex);

    node.clearCache();
    node.filters([]);
    if (!node.isCached()) node.cache();

    node.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
    node.brightness(0);
    node.red(rgba.r);
    node.green(rgba.g);
    node.blue(rgba.b);
    node.alpha(1);
    node.getLayer()?.batchDraw();
  };

  const waitUntilImageAvailable = (encryptedId, maxRetries = 30, delay = 100) => {
    let attempts = 0;

    const tryLoad = () =>
      new Promise((resolve, reject) => {
        const check = () => {
          const url = imageMapRef.current[encryptedId]; // ✅ dùng ref mới nhất
          if (url) {
            resolve(url);
          } else if (attempts >= maxRetries) {
            reject(new Error("Image not found in imageMap"));
          } else {
            attempts += 1;
            setTimeout(check, delay);
          }
        };
        check();
      });

    return tryLoad();
  };

  const loadImagesSafely = async (items = []) =>
    Promise.all(
      items.map((item) => {
        if (item.image) {
          // 🔄 Đã có ảnh, không cần load lại
          return Promise.resolve(item);
        }

        return new Promise((resolve) => {
          const img = new Image();
          img.src = item.src;
          img.onload = () => resolve({ ...item, image: img });
          img.onerror = () => resolve({ ...item, image: null }); // fallback
        });
      })
    );

  const handleSetCanvasByLayer = async (item, options = {}) => {
    const {
      skipReset = false,
      canvasStatesOverride = null,
      skipLayerColorRestore = false,
    } = options;

    const mergedState = {
      texts: [],
      uploadedImages: [],
      stickers: [],
      layerColorMap: {},
    };

    // ✅ Merge tất cả state của các layer thuộc mặt này
    const { attachType } = item;

    const filteredList = layerOptions.filter((l) =>
      item.attachType === 4 ? [3, 4].includes(l.layerType) : l.layerType === item.attachType
    );

    if (!filteredList || filteredList.length === 0) return;

    const highlightLayer = filteredList[0]; // luôn là layer chính
    const newLayerId = highlightLayer?.layerId;
    if (newLayerId) {
      setSelectedLayerId(newLayerId);
    }

    // ✅ Reset toàn bộ trước khi restore nếu không skipReset
    if (!skipReset) {
      resetCanvasState();
    }

    const statesToUse = canvasStatesOverride || canvasStates;

    // 👉 Lưu lại canvas trước khi đổi layer
    if (!isRestoringEdit) saveCurrentCanvasState();
    setOverlayLayers([]);

    // ✅ Layer hiệu ứng (layer đầu tiên)
    const effectLayer = filteredList[0];
    const effectEncryptedId = effectLayer?.attachment?.encryptedId;
    let effectImgUrl = null;
    if (effectEncryptedId) {
      try {
        effectImgUrl = await waitUntilImageAvailable(effectEncryptedId);
      } catch (err) {
        console.warn("Không thể tải ảnh hiệu ứng:", err);
        effectImgUrl = null;
      }
    }
    if (effectImgUrl) {
      const img = new Image();
      img.onload = () => {
        setHighlightImage(img);
        const imgW = img.width;
        const imgH = img.height;
        if (!imageSize.width || imgW > imageSize.width) {
          setImageSize({ width: imgW, height: imgH }); // giữ nguyên gốc
        }

        // ✅ Thêm áp màu highlight sau khi set ảnh xong
        const key = `${attachType}-${highlightLayer?.layerId}`;
        const hex = mergedState.layerColorMap[key];
        if (hex && highlightImageRef.current) {
          const rgba = hexToRGBA(hex);
          const node = highlightImageRef.current;
          node.clearCache();
          node.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
          node.red(rgba.r);
          node.green(rgba.g);
          node.blue(rgba.b);
          node.alpha(1);
          node.brightness(0);
          node.cache();
          node.getLayer()?.batchDraw();
        }
      };
      img.src = effectImgUrl; // Phải set sau `onload`
    } else {
      setHighlightImage(null);
    }

    filteredList.forEach((layer) => {
      const key = `${attachType}-${layer.layerId}`;
      const state = statesToUse[key];
      if (state) {
        const filteredTexts = (state.texts || [])
          .filter((t) => t.attachType === attachType && t.layerKey === key)
          .map((t) => ({ ...t }));
        const filteredImages = (state.uploadedImages || []).filter(
          (img) => img.attachType === attachType && img.layerKey === key
        );
        const filteredStickers = (state.stickers || []).filter(
          (s) => s.attachType === attachType && s.layerKey === key
        );

        mergedState.texts.push(...filteredTexts);
        mergedState.uploadedImages.push(...filteredImages);
        mergedState.stickers.push(...filteredStickers);

        Object.entries(state.layerColorMap || {}).forEach(([layerKey, color]) => {
          if (key === layerKey) mergedState.layerColorMap[layerKey] = color;
        });
      }
    });

    const uploadedImagesWithImage = await loadImagesSafely(mergedState.uploadedImages);
    const stickersWithImage = await loadImagesSafely(mergedState.stickers);
    setTexts(mergedState.texts);
    setUploadedImages(uploadedImagesWithImage);
    setStickers(stickersWithImage);
    if (!skipLayerColorRestore) {
      setLayerColorMap((prev) => ({
        ...prev,
        ...mergedState.layerColorMap,
      }));
    }

    // ✅ Các layer còn lại là overlay để tô màu
    const contentLayers = filteredList.slice(1);

    if (newLayerId) {
      setSelectedLayerId(newLayerId);
    }

    // ✅ Load hiệu ứng mờ (highlightImage)
    if (!effectImgUrl) {
      setHighlightImage(null);
    } else {
      const img = new Image();
      img.src = effectImgUrl;
      img.onload = () => {
        setHighlightImage(img);
        const imgW = img.width;
        const imgH = img.height;
        if (!imageSize.width || imgW > imageSize.width) {
          setImageSize({ width: imgW, height: imgH }); // giữ nguyên gốc
        }

        // ✅ Thêm áp màu highlight sau khi set ảnh xong
        const key = `${attachType}-${highlightLayer?.layerId}`;
        const hex = mergedState.layerColorMap[key];
        if (hex && highlightImageRef.current) {
          const rgba = hexToRGBA(hex);
          const node = highlightImageRef.current;
          node.clearCache();
          node.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
          node.red(rgba.r);
          node.green(rgba.g);
          node.blue(rgba.b);
          node.alpha(1);
          node.brightness(0);
          node.cache();
          node.getLayer()?.batchDraw();
        }
      };
    }

    // ✅ Load overlay layers
    const images = await Promise.all(
      contentLayers
        .map((layer, idx) => {
          const url = imageMapRef.current[layer?.attachment?.encryptedId];
          if (!url) return null;

          return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => {
              // ✅ Tính scale giống như highlightImage
              const imgW = img.width;
              const imgH = img.height;
              // const maxW = canvasWidth;
              // const maxH = canvasHeight;
              const scaleW = imageSize.width / imgW;
              const scaleH = imageSize.height / imgH;
              const scale = Math.min(scaleW, scaleH, 1);

              resolve({
                id: `overlay-${layer.layerId || idx}`,
                image: img,
                layerId: layer.layerId,
                layerName: layer.layerName,
                width: imgW * scale, // ✅ thêm width
                height: imgH * scale, // ✅ thêm height
              });
            };
          });
        })
        .filter(Boolean)
    );

    // ✅ Clear cache trước khi set
    overlayKonvaRefs.current.forEach((ref) => {
      if (ref) {
        ref.clearCache();
        ref.filters([]);
        ref.getLayer()?.batchDraw();
      }
    });
    overlayKonvaRefs.current = [];

    if (highlightImageRef.current) {
      highlightImageRef.current.clearCache();
      highlightImageRef.current.filters([]);
      highlightImageRef.current.getLayer()?.batchDraw();
    }

    setOverlayLayers(images);
    if (images.length === 0) {
      setSelectedLayerId(null);
    }

    // ✅ Ghi nhận layer đang chọn
    setCurrentAttachType(item.attachType);
  };

  // const getMatchedLayerCode = () => {
  //   const selectedLayer = layerOptions.find((l) => l.layerId === selectedLayerId);
  //   return selectedLayer?.layerCode?.toString() || null;
  // };

  // const matcheSnapshotLayerCode = getMatchedLayerCode();

  // const hasUndoForCurrentAttachType = !!undoStacks[matcheSnapshotLayerCode]?.some(
  //   (snap) => snap.attachType === currentAttachType
  // );

  // const hasRedoForCurrentAttachType = !!redoStacks[matcheSnapshotLayerCode]?.some(
  //   (snap) => snap.attachType === currentAttachType
  // );

  // const loadImagesSnapShot = async (items = []) =>
  //   Promise.all(
  //     items.map(
  //       (item) =>
  //         new Promise((resolve) => {
  //           const img = new Image();
  //           img.src = item.src;
  //           img.onload = () => resolve({ ...item, image: img });
  //           img.onerror = () => resolve({ ...item, image: null });
  //         })
  //     )
  //   );

  // custom hook
  function useDidUpdateEffect(fn, deps) {
    const didMount = useRef(false);

    useEffect(() => {
      if (didMount.current) {
        fn();
      } else {
        didMount.current = true;
      }
    }, deps);
  }

  useDidUpdateEffect(() => {
    if (!pendingUndoSnapshot) return;

    const currentItem = { attachType: currentAttachType };

    const override = {};
    Object.keys(pendingUndoSnapshot.layerColorMap || {}).forEach((layerKey) => {
      override[layerKey] = {
        texts: pendingUndoSnapshot.texts,
        uploadedImages: pendingUndoSnapshot.uploadedImages,
        stickers: pendingUndoSnapshot.stickers,
        layerColorMap: {
          [layerKey]: pendingUndoSnapshot.layerColorMap[layerKey],
        },
      };
    });

    handleSetCanvasByLayer(currentItem, {
      skipLayerColorRestore: true,
      canvasStatesOverride: override,
    });

    setPendingUndoSnapshot(null); // cleanup
  }, [layerColorMap]); // chỉ chạy khi màu được set xong

  const handleUndo = useCallback(
    debounce(async () => {
      if (!currentAttachType || !selectedLayerId) return;
      const layerKey = `${currentAttachType}-${selectedLayerId}`;
      const stack = undoStacks[layerKey] || [];
      if (!stack.length) return;

      const last = stack[stack.length - 1];

      // Push current state to redo stack
      setRedoStacks((prev) => ({
        ...prev,
        [layerKey]: [
          ...(prev[layerKey] || []),
          {
            texts: texts.filter(
              (t) => t.layerKey === layerKey && t.attachType === currentAttachType
            ),
            uploadedImages: uploadedImages
              .filter((img) => img.layerKey === layerKey && img.attachType === currentAttachType)
              .map((img) => ({ ...img, src: img.image?.src, image: undefined })),
            stickers: stickers
              .filter((s) => s.layerKey === layerKey && s.attachType === currentAttachType)
              .map((s) => ({ ...s, src: s.image?.src, image: undefined })),
            layerColorMap: { ...layerColorMapRef.current },
          },
        ],
      }));

      // Remove from undo stack
      setUndoStacks((prev) => ({ ...prev, [layerKey]: stack.slice(0, -1) }));

      // Restore state
      const loadedImages = await loadImagesSafely(last.uploadedImages);
      const loadedStickers = await loadImagesSafely(last.stickers);
      setTexts(last.texts);
      setUploadedImages(loadedImages);
      setStickers(loadedStickers);

      // Restore colors
      const color = last.layerColorMap[layerKey];
      if (color) {
        applyHighlightFilter(selectedLayerId);
      } else {
        // Xóa bộ lọc nếu không có màu
        const node = highlightImageRef.current;
        if (node) {
          node.clearCache();
          node.filters([]);
          node.getLayer()?.batchDraw();
        }
      }

      setLayerColorMap((prev) => ({ ...prev, ...last.layerColorMap }));

      Object.entries(last.layerColorMap || {}).forEach(([key, hex]) => {
        const rgba = hexToRGBA(hex);
        const overlayIdx = overlayKonvaRefs.current.findIndex(
          (ref) => ref?.attrs?.id === `overlay-${key.split("-")[1]}`
        );
        if (overlayIdx !== -1) {
          const node = overlayKonvaRefs.current[overlayIdx];
          node.clearCache();
          node.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
          node.red(rgba.r);
          node.green(rgba.g);
          node.blue(rgba.b);
          node.alpha(1);
          node.brightness(0);
          node.cache();
          node.getLayer()?.batchDraw();
        }
      });
      // ✅ Cập nhật canvasStates cả nội dung và màu
      const selectedLayer = layerOptions.find((l) => l.layerId === selectedLayerId);
      const matchedLayerCode = selectedLayer?.layerCode?.toString();
      const matchedLayers = layerOptions.filter(
        (l) => l.layerCode?.toString() === matchedLayerCode && l.isColorChange === 1
      );

      const sharedLayer = matchedLayers.find(
        (layer) => `${layer.layerType}-${layer.layerId}` in last.layerColorMap
      );
      const sharedKey = sharedLayer && `${sharedLayer.layerType}-${sharedLayer.layerId}`;
      const sharedColor = sharedKey ? last.layerColorMap[sharedKey] : null;
      const newLayerColorMap = {};
      if (sharedColor) {
        matchedLayers.forEach((layer) => {
          const key = `${layer.layerType}-${layer.layerId}`;
          newLayerColorMap[key] = sharedColor;
        });
      }
      setCanvasStates((prev) => {
        const updated = {
          ...prev,
          [layerKey]: {
            texts: last.texts,
            uploadedImages: loadedImages,
            stickers: loadedStickers,
          },
        };

        // ✅ Gán cùng 1 layerColorMap cho tất cả các layer cùng mã
        matchedLayers.forEach((layer) => {
          const key = `${layer.layerType}-${layer.layerId}`;
          updated[key] = {
            ...(updated[key] || {}),
            layerColorMap: { ...newLayerColorMap },
          };
        });

        return updated;
      });

      if (stageRef.current) stageRef.current.batchDraw();
    }, 100),
    [currentAttachType, selectedLayerId, undoStacks, texts, uploadedImages, stickers]
  );

  const handleRedo = useCallback(
    debounce(async () => {
      if (!currentAttachType || !selectedLayerId) return;
      const layerKey = `${currentAttachType}-${selectedLayerId}`;
      const stack = redoStacks[layerKey] || [];
      if (!stack.length) return;

      const last = stack[stack.length - 1];

      // Push current state to undo stack
      setUndoStacks((prev) => ({
        ...prev,
        [layerKey]: [
          ...(prev[layerKey] || []),
          {
            texts: texts.filter(
              (t) => t.layerKey === layerKey && t.attachType === currentAttachType
            ),
            uploadedImages: uploadedImages
              .filter((img) => img.layerKey === layerKey && img.attachType === currentAttachType)
              .map((img) => ({ ...img, src: img.image?.src, image: undefined })),
            stickers: stickers
              .filter((s) => s.layerKey === layerKey && s.attachType === currentAttachType)
              .map((s) => ({ ...s, src: s.image?.src, image: undefined })),
            layerColorMap: { ...layerColorMapRef.current },
          },
        ],
      }));

      // Remove from redo stack
      setRedoStacks((prev) => ({ ...prev, [layerKey]: stack.slice(0, -1) }));

      const loadedImages = await loadImagesSafely(last.uploadedImages);
      const loadedStickers = await loadImagesSafely(last.stickers);
      setTexts(last.texts);
      setUploadedImages(loadedImages);
      setStickers(loadedStickers);

      setLayerColorMap((prev) => ({ ...prev, ...last.layerColorMap }));
      Object.entries(last.layerColorMap || {}).forEach(([key, hex]) => {
        const rgba = hexToRGBA(hex);
        const overlayIdx = overlayKonvaRefs.current.findIndex(
          (ref) => ref?.attrs?.id === `overlay-${key.split("-")[1]}`
        );
        if (overlayIdx !== -1) {
          const node = overlayKonvaRefs.current[overlayIdx];
          node.clearCache();
          node.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
          node.red(rgba.r);
          node.green(rgba.g);
          node.blue(rgba.b);
          node.alpha(1);
          node.brightness(0);
          node.cache();
          node.getLayer()?.batchDraw();
        }
      });
      const selectedLayer = layerOptions.find((l) => l.layerId === selectedLayerId);
      const matchedLayerCode = selectedLayer?.layerCode?.toString();

      const matchedLayers = layerOptions.filter(
        (l) => l.layerCode?.toString() === matchedLayerCode && l.isColorChange === 1
      );

      const sharedLayer = matchedLayers.find(
        (layer) => `${layer.layerType}-${layer.layerId}` in last.layerColorMap
      );
      const sharedKey = sharedLayer && `${sharedLayer.layerType}-${sharedLayer.layerId}`;
      const sharedColor = sharedKey ? last.layerColorMap[sharedKey] : null;
      const newLayerColorMap = {};
      if (sharedColor) {
        matchedLayers.forEach((layer) => {
          const key = `${layer.layerType}-${layer.layerId}`;
          newLayerColorMap[key] = sharedColor;
        });
      }

      setCanvasStates((prev) => {
        const updated = {
          ...prev,
          [layerKey]: {
            texts: last.texts,
            uploadedImages: loadedImages,
            stickers: loadedStickers,
          },
        };

        // ✅ Gán cùng 1 layerColorMap cho tất cả các layer cùng mã
        matchedLayers.forEach((layer) => {
          const key = `${layer.layerType}-${layer.layerId}`;
          updated[key] = {
            ...(updated[key] || {}),
            layerColorMap: { ...newLayerColorMap },
          };
        });

        return updated;
      });

      if (stageRef.current) stageRef.current.batchDraw();
    }, 100),
    [currentAttachType, selectedLayerId, redoStacks, texts, uploadedImages, stickers]
  );

  const focusThumbnailAndLoadCanvas = async (attach) => {
    // ✅ Lấy tất cả layers thuộc mặt này
    const layersForFace = layerOptions.filter((l) =>
      attach.attachType === 4 ? [3, 4].includes(l.layerType) : l.layerType === attach.attachType
    );

    // ✅ Ưu tiên layer đầu tiên (hiệu ứng), hoặc fallback layer thứ 2
    const matchedLayer = layersForFace[0] || layersForFace[1];
    if (!matchedLayer) return;

    setCurrentAttachType(attach.attachType);
    await handleSetCanvasByLayer(attach);
  };

  const applyColorToSelectedLayer = (hexColor) => {
    setIsResetting(false);
    if (!hexColor || typeof hexColor !== "string") {
      console.warn("Invalid hexColor provided:", hexColor);
      return;
    }
    pushUndoSnapshot();

    // Step 1: Tìm layer đang chọn và các layer có cùng layerCode
    let matchedLayers = [];
    let matchedLayerCode = null;
    if (selectedLayerId) {
      const selectedLayer = layerOptions.find((l) => l.layerId === selectedLayerId);
      if (!selectedLayer) {
        console.warn("Selected layer not found for ID:", selectedLayerId);
        return;
      }
      matchedLayerCode = selectedLayer.layerCode;
      matchedLayers = layerOptions.filter(
        (l) => l.layerCode === matchedLayerCode && l.isColorChange === 1
      );
    } else {
      matchedLayers = layerOptions.filter((l) => l.isColorChange === 1);
      matchedLayerCode = matchedLayers[0]?.layerCode;
    }

    if (!matchedLayers.length || !matchedLayerCode) {
      console.warn("No matched layers or layerCode found for color application");
      return;
    }

    console.log("Applying color:", { hexColor, matchedLayerCode, matchedLayers });

    // Step 2: Cập nhật layerColorMap và canvasStates

    // const newColorMap = { ...layerColorMap };
    // const newCanvasStates = { ...canvasStates };
    // // Xóa màu cũ của các layer có cùng layerCode
    // matchedLayers.forEach((layer) => {
    //   const key = `${layer.layerType}-${layer.layerId}`;
    //   newColorMap[key] = hexColor;

    //   // Cập nhật canvasStates
    //   newCanvasStates[key] = {
    //     ...(newCanvasStates[key] || {
    //       texts: [],
    //       uploadedImages: [],
    //       stickers: [],
    //       layerColorMap: {},
    //     }),
    //     layerColorMap: { [key]: hexColor },
    //   };
    // });
    const newColorMap = { ...layerColorMap };
    const newCanvasStates = { ...canvasStates };

    // Cập nhật màu cho tất cả layer có cùng layerCode
    Object.entries(canvasStates).forEach(([attachType, canvas]) => {
      const oldLayerColorMap = canvas.layerColorMap || {};
      const updatedLayerColorMap = { ...oldLayerColorMap };

      Object.keys(oldLayerColorMap).forEach((layerKey) => {
        const layer = layerOptions.find((l) => `${l.layerType}-${l.layerId}` === layerKey);
        if (layer && layer.layerCode === matchedLayerCode && layer.isColorChange === 1) {
          updatedLayerColorMap[layerKey] = hexColor;
          newColorMap[layerKey] = hexColor;
        }
      });

      newCanvasStates[attachType] = {
        ...canvas,
        layerColorMap: updatedLayerColorMap,
      };
    });

    // Đảm bảo layer đang chọn trong matchedLayers được cập nhật đúng
    matchedLayers.forEach((layer) => {
      const key = `${layer.layerType}-${layer.layerId}`;
      newColorMap[key] = hexColor;

      newCanvasStates[key] = {
        ...(newCanvasStates[key] || {
          texts: [],
          uploadedImages: [],
          stickers: [],
          layerColorMap: {},
        }),
        layerColorMap: {
          ...((newCanvasStates[key] && newCanvasStates[key].layerColorMap) || {}),
          [key]: hexColor,
        },
      };
    });
    // Step 3: Cập nhật state
    setLayerColorMap(newColorMap);
    setCanvasStates(newCanvasStates);

    // Step 4: Áp dụng màu cho Konva nodes
    const rgba = hexToRGBA(hexColor);
    matchedLayers.forEach((layer) => {
      // const key = `${layer.layerType}-${layer.layerId}`;
      const isHighlightLayer = layer.layerId === matchedLayers[0]?.layerId; // Layer đầu tiên thường là highlight

      if (isHighlightLayer && highlightImageRef.current) {
        highlightImageRef.current.clearCache();
        highlightImageRef.current.filters([Konva.Filters.RGBA, Konva.Filters.Brighten]);
        highlightImageRef.current.red(rgba.r);
        highlightImageRef.current.green(rgba.g);
        highlightImageRef.current.blue(rgba.b);
        highlightImageRef.current.alpha(1);
        highlightImageRef.current.brightness(0);
        highlightImageRef.current.cache();
        highlightImageRef.current.getLayer()?.batchDraw();
      }

      const overlayIndex = overlayLayers.findIndex((ol) => ol.layerId === layer.layerId);
      if (overlayIndex !== -1 && overlayKonvaRefs.current[overlayIndex]) {
        const ref = overlayKonvaRefs.current[overlayIndex];
        ref.clearCache();
        ref.filters([Konva.Filters.RGBA]);
        ref.red(rgba.r);
        ref.green(rgba.g);
        ref.blue(rgba.b);
        ref.alpha(1);
        ref.cache();
        ref.getLayer()?.batchDraw();
      }
    });

    console.log("After applying color:", {
      layerColorMap: newColorMap,
      canvasStates: newCanvasStates,
    });
  };

  const saveCanvasToLocalStorage = () => {
    if (isResetting) return;
    const stateToSave = {
      texts,
      uploadedImages: uploadedImages.map((img) => ({
        id: img.id,
        encryptedId: img.encryptedId, // thay vì src
        x: img.x,
        y: img.y,
        width: img.width,
        height: img.height,
        rotation: img.rotation || 0,
        flipX: img.flipX || false,
      })),
      layerColorMap,
      currentAttachType,
      selectedProduct,
    };

    localStorage.setItem("canvasDesignState", JSON.stringify(stateToSave));
  };
  useEffect(() => {
    const areImagesLoaded =
      uploadedImages.every((img) => img.image && img.image.complete) &&
      (!highlightImage || highlightImage.complete);

    if (!areImagesLoaded) return;

    saveCanvasToLocalStorage();
  }, [texts, uploadedImages, layerColorMap, currentAttachType, highlightImage]);

  useEffect(() => {
    const saved = localStorage.getItem("canvasDesignState");
    if (!saved) return;

    const {
      currentAttachType: savedAttachType,
      selectedProduct: savedProduct,
      texts: savedTexts,
      layerColorMap: savedColorMap,
      uploadedImages: savedImages,
    } = JSON.parse(saved);

    setCurrentAttachType(savedAttachType || null);
    setSelectedProduct(savedProduct || null);
    setTexts(savedTexts || []);
    setLayerColorMap(savedColorMap || {});

    const loadImages = async () => {
      const loadedImages = await Promise.all(
        (savedImages || []).map(
          (img) =>
            new Promise((resolve) => {
              const imageObj = new window.Image();
              imageObj.src = img.src;
              imageObj.onload = () =>
                resolve({
                  ...img,
                  image: imageObj,
                });
            })
        )
      );
      setUploadedImages(loadedImages);
    };

    loadImages();
  }, []);

  const waitForCanvasReady = () =>
    new Promise((resolve) => {
      const interval = setInterval(() => {
        const allImagesReady =
          (!highlightImage || highlightImage.complete) &&
          overlayLayers.every((l) => l.image?.complete) &&
          uploadedImages.every((img) => img.image?.complete);

        if (allImagesReady) {
          clearInterval(interval);
          resolve();
        }
      }, 100); // kiểm tra mỗi 100ms
    });

  const ensureLayerImagesReady = async (layers = []) => {
    const imageTasks = [];

    layers.forEach((layer) => {
      const id = layer?.attachment?.encryptedId;
      if (id && !imageMapRef.current[id]) {
        imageTasks.push(
          getImageUrl(`/api/public/attachments/downloadFile/${id}`).then((url) => ({
            id,
            url,
          }))
        );
      }
    });

    const results = await Promise.all(imageTasks);
    const newMap = {};
    results.forEach((res) => {
      if (res?.url) newMap[res.id] = res.url;
    });
    setImageMap((prev) => ({ ...prev, ...newMap }));

    await Promise.all(
      layers
        .map((l) => l?.attachment?.encryptedId)
        .filter(Boolean)
        .map((id) => waitUntilImageAvailable(id))
    );
  };

  const ensureFocusAndLoadCanvas = async (attach, options = {}) => {
    const { skipOverlay = false, skipOverlayGeneration = false } = options;

    if (!attach?.encryptedId) return;

    try {
      const layersForFace = layerOptions.filter((l) =>
        attach.attachType === 4 ? [3, 4].includes(l.layerType) : l.layerType === attach.attachType
      );

      await ensureLayerImagesReady(layersForFace);
      await waitUntilImageAvailable(attach.encryptedId);

      await focusThumbnailAndLoadCanvas(attach);

      if (attach.attachType === 4 && !skipOverlay && !skipOverlayGeneration) {
        saveCurrentCanvasState();
        // setIsGeneratingOverlay(true);

        const previousState = {
          texts,
          uploadedImages,
          stickers,
          layerColorMap,
          currentAttachType,
          selectedLayerId,
        };

        const files = await renderAllSidesToFiles({
          pixelRatio: 2,
          quality: 1,
          skipRestore: true,
          selectedProduct,
          layerOptions,
          canvasStates,
          getBaseZoomDataURL,
          handleSetCanvasByLayer,
          waitForCanvasReady,
          saveCurrentCanvasState,
          setTexts,
          setUploadedImages,
          setStickers,
          setLayerColorMap,
          setCurrentAttachType,
          setSelectedLayerId,
          imageMap,
          previousState,
          ensureFocusAndLoadCanvas,
          selectedTextId,
          selectedImageId,
          selectedStickerId,
          resetCanvasState,
        });

        const frontFile = files.find((file) => file.name.includes("side-1"));
        if (!frontFile) {
          setIsGeneratingOverlay(false);
          return;
        }
        const frontUrl = URL.createObjectURL(frontFile);
        const img = new Image();
        img.onload = () => {
          setOverlayImageFront(img);
          setOverlayFrontSize({ width: img.width, height: img.height }); // ✅ lưu kích thước gốc
          // setIsGeneratingOverlay(false);
        };
        img.src = frontUrl;
      }
    } catch (err) {
      console.warn("Không thể load ảnh trong ensureFocusAndLoadCanvas:", err);
    }
    // finally {
    //   setIsGeneratingOverlay(false);
    // }
  };

  const resetCanvas = async () => {
    setIsResetting(true);
    console.log("🧹 Resetting canvas to initial state...");

    // Reset trạng thái chung
    setTexts([]);
    setUploadedImages([]);
    setStickers([]);
    setUndoStacks({});
    setRedoStacks({});
    setSelectedTextId(null);
    setSelectedImageId(null);
    setSelectedStickerId(null);
    setSelectedLayerId(null);
    setZoom(baseZoom);
    setShowWatermark(true);

    // Xóa toàn bộ màu layer và canvasStates
    setLayerColorMap({});
    setCanvasStates({});

    // Xóa bộ lọc ảnh overlay
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        overlayKonvaRefs.current.forEach((ref) => {
          if (ref) {
            ref.filters([]);
            ref.red?.(0);
            ref.green?.(0);
            ref.blue?.(0);
            ref.alpha?.(0);
            ref.clearCache();
            ref.getLayer()?.batchDraw();
          }
        });

        if (highlightImageRef.current) {
          highlightImageRef.current.filters([]);
          highlightImageRef.current.clearCache();
          highlightImageRef.current.getLayer()?.batchDraw();
        }

        resolve();
      });
    });
    setZoom(1); // ✅ Reset lại zoom
  };

  const selectByMatLayer = async (attach, options = {}) => {
    try {
      setIsGeneratingOverlay(true);
      setShowWatermark(false);
      await ensureFocusAndLoadCanvas(attach, options);
    } catch (err) {
      Swal.fire("Lỗi", "Không thể tạo ảnh xem trước từ server", "error");
    } finally {
      setShowWatermark(true);
      setIsGeneratingOverlay(false);
    }
  };

  const frontScale = useMemo(() => {
    if (!overlayFrontSize.width || !overlayFrontSize.height) return 1;

    const scaleW = imageSize.width / overlayFrontSize.width;
    const scaleH = imageSize.height / overlayFrontSize.height;
    const scale = Math.min(scaleW, scaleH, 1); // giữ đúng tỷ lệ
    return scale;
  }, [imageSize, overlayFrontSize]);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      if (!selectedProduct || layerOptions.length === 0 || isRestoringEdit) return;

      // if (currentAttachType) return;

      const firstAttach = selectedProduct.attachments?.find((a) =>
        [1, 2, 4].includes(a.attachType)
      );
      if (!firstAttach || !firstAttach.encryptedId) return;

      try {
        await waitUntilImageAvailable(firstAttach.encryptedId); // ✅ luôn đợi ảnh
        if (isMounted) {
          await ensureFocusAndLoadCanvas(firstAttach); // ✅ luôn load canvas
        }
      } catch (err) {
        console.warn("Không thể load ảnh mặt đầu tiên:", err);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [selectedProduct, layerOptions, isRestoringEdit]);

  const handleExportImage = async () => {
    const isValidUser = await verifyUserLoggedIn();
    let isPreview = false;
    const pixelRatio = 2;
    const quality = 1;

    if (!isValidUser) {
      const result = await Swal.fire({
        title: "Khuyến cáo",
        text: "Đăng nhập để tải hình chất lượng cao",
        icon: "warning",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Tiếp tục dung lượng thấp",
        denyButtonText: "Đăng nhập",
        // cancelButtonText: "Hủy",
        reverseButtons: true,
        showCloseButton: true,
      });

      if (result.isDenied) {
        const canvasStatesToSave = {};
        Object.entries(canvasStates).forEach(([key, state]) => {
          canvasStatesToSave[key] = {
            texts: state.texts || [],
            uploadedImages: (state.uploadedImages || []).map((img) => ({
              ...img,
              src: img.image?.src,
              image: undefined,
              attachType: img.attachType,
              layerKey: img.layerKey,
            })),
            stickers: (state.stickers || []).map((s) => ({
              ...s,
              src: s.image?.src,
              image: undefined,
              attachType: s.attachType,
              layerKey: s.layerKey,
            })),
            layerColorMap: state.layerColorMap || {},
          };
        });

        const tempDesignData = {
          canvasStates: canvasStatesToSave,
          selectedProduct,
          currentAttachType,
          selectedLayerId,
          templateId: selectedProduct?.templateId,
        };

        const jsonBlob = new Blob([JSON.stringify(tempDesignData)], { type: "application/json" });
        const jsonFile = new File([jsonBlob], "tempDesign.json", { type: "application/json" });

        try {
          const { fullUrl } = await uploadTempImage(jsonFile);
          const encodedId = fullUrl.split("/").pop(); // chỉ lấy phần mã hóa
          localStorage.setItem("tempDesignBeforeLogin", encodedId);
        } catch (err) {
          console.error("❌ Upload tempDesign thất bại:", err);
        }

        navigate("/authentication/sign-in");
        return;
      }

      if (result.isDismissed) {
        return;
      }

      isPreview = false;
    } else {
      isPreview = true;
    }

    try {
      setShowWatermark(false);
      setIsGeneratingOverlay(true);

      // 👉 Ép render manocanh để sinh ảnh overlay mặt trước
      const mannequin = selectedProduct?.attachments?.find((att) => att.attachType === 4);
      if (mannequin) {
        await ensureFocusAndLoadCanvas(mannequin);
      }

      const previousState = {
        texts,
        uploadedImages,
        stickers,
        layerColorMap,
        currentAttachType,
        selectedLayerId,
      };
      const files = await renderAllSidesToFiles({
        pixelRatio,
        quality,
        skipRestore: true,
        selectedProduct,
        layerOptions,
        canvasStates,
        getBaseZoomDataURL,
        handleSetCanvasByLayer,
        waitForCanvasReady,
        saveCurrentCanvasState,
        setTexts,
        setUploadedImages,
        setStickers,
        setLayerColorMap,
        setCurrentAttachType,
        setSelectedLayerId,
        imageMap,
        previousState,
        ensureFocusAndLoadCanvas,
        selectedTextId,
        selectedImageId,
        selectedStickerId,
        resetCanvasState,
      });
      if (!files || files.length === 0) {
        Swal.fire("Lỗi", "Không có ảnh để xuất", "error");
        return;
      }

      // 👉 Crop từng ảnh sau khi render
      let croppedFiles;
      if (isMobile2)
        croppedFiles = await Promise.all(files.map((file) => cropImageFile(file, 20, false)));
      else
        croppedFiles = await Promise.all(
          files.map((file) => cropImageFile(file, 20, true, 1000, 1400))
        );
      const blob = await fetchPreviewCombinedImage(croppedFiles, isPreview);
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.download = `design-${Date.now()}.${isPreview ? "jpg" : "png"}`; // ✅ Đổi tên file
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);

      await Swal.fire({
        icon: "success",
        title: "Xuất ảnh thành công",
        text: isValidUser
          ? "Bạn đã tải ảnh chất lượng cao."
          : "Ảnh đã được tải với chất lượng thấp.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Lỗi xuất ảnh:", err);
      Swal.fire("Lỗi", "Xuất ảnh thất bại", "error");
    } finally {
      setIsGeneratingOverlay(false);
      setShowWatermark(true);
    }
  };

  const handleShareToFacebook = async () => {
    const isValidUser = await verifyUserLoggedIn();
    const pixelRatio = 2;
    const quality = 1;
    let isPreview = false;

    if (!isValidUser) {
      const result = await Swal.fire({
        title: "Khuyến cáo",
        text: "Đăng nhập để chia sẻ hình chất lượng cao",
        icon: "warning",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Tiếp tục với dung lượng thấp",
        denyButtonText: "Đăng nhập",
        // cancelButtonText: "Hủy",
        reverseButtons: true,
        showCloseButton: true,
      });

      if (result.isDenied) {
        const canvasStatesToSave = {};
        Object.entries(canvasStates).forEach(([key, state]) => {
          canvasStatesToSave[key] = {
            texts: state.texts || [],
            uploadedImages: (state.uploadedImages || []).map((img) => ({
              ...img,
              src: img.image?.src,
              image: undefined,
              attachType: img.attachType,
              layerKey: img.layerKey,
            })),
            stickers: (state.stickers || []).map((s) => ({
              ...s,
              src: s.image?.src,
              image: undefined,
              attachType: s.attachType,
              layerKey: s.layerKey,
            })),
            layerColorMap: state.layerColorMap || {},
          };
        });

        const tempDesignData = {
          canvasStates: canvasStatesToSave,
          selectedProduct,
          currentAttachType,
          selectedLayerId,
          templateId: selectedProduct?.templateId,
        };

        const jsonBlob = new Blob([JSON.stringify(tempDesignData)], { type: "application/json" });
        const jsonFile = new File([jsonBlob], "tempDesign.json", { type: "application/json" });

        try {
          const { fullUrl } = await uploadTempImage(jsonFile);
          const encodedId = fullUrl.split("/").pop(); // chỉ lấy phần mã hóa
          localStorage.setItem("tempDesignBeforeLogin", encodedId);
        } catch (err) {
          console.error("❌ Upload tempDesign thất bại:", err);
        }

        navigate("/authentication/sign-in");
        return;
      }

      if (result.isDismissed) return;
      isPreview = false;
    } else {
      isPreview = true;
    }

    try {
      setShowWatermark(false);
      setIsGeneratingPreview(true);

      const mannequin = selectedProduct?.attachments?.find((att) => att.attachType === 4);
      if (mannequin) {
        await ensureFocusAndLoadCanvas(mannequin);
      }

      const previousState = {
        texts,
        uploadedImages,
        stickers,
        layerColorMap,
        currentAttachType,
        selectedLayerId,
      };

      const files = await renderAllSidesToFiles({
        pixelRatio,
        quality,
        skipRestore: false,
        selectedProduct,
        layerOptions,
        canvasStates,
        getBaseZoomDataURL,
        handleSetCanvasByLayer,
        waitForCanvasReady,
        saveCurrentCanvasState,
        setTexts,
        setUploadedImages,
        setStickers,
        setLayerColorMap,
        setCurrentAttachType,
        setSelectedLayerId,
        imageMap,
        previousState,
        ensureFocusAndLoadCanvas,
        selectedTextId,
        selectedImageId,
        selectedStickerId,
        resetCanvasState,
      });

      // 👉 Crop từng ảnh sau khi render
      let croppedFiles;
      if (isMobile2)
        croppedFiles = await Promise.all(files.map((file) => cropImageFile(file, 20, false)));
      else
        croppedFiles = await Promise.all(
          files.map((file) => cropImageFile(file, 20, true, 1000, 1400))
        );
      const blob = await fetchPreviewCombinedImage(croppedFiles, isPreview);
      if (!blob) throw new Error("Không nhận được ảnh từ server");

      // ✅ Upload lại ảnh này để lấy link thật
      const file = new File([blob], "design.png", { type: "image/png" });
      const { fullUrl } = await uploadTempImage(file);
      if (!fullUrl) throw new Error("Không thể upload ảnh");

      setShareLink(fullUrl);
      setShowShareDialog(true);
    } catch (err) {
      console.error("Lỗi chia sẻ:", err);
      Swal.fire("Lỗi", err.message || "Không thể tạo ảnh chia sẻ", "error");
    } finally {
      setIsGeneratingPreview(false);
      setShowWatermark(true);
    }
  };

  const handleSaveDesign = async () => {
    if (!selectedProduct?.templateId) {
      Swal.fire("Thông báo", "Chưa chọn mẫu sản phẩm để lưu thiết kế", "info");
      return;
    }

    const isValidUser = await verifyUserLoggedIn();
    if (!isValidUser) {
      const result = await Swal.fire({
        icon: "warning",
        title: "Bạn cần đăng nhập",
        text: "Vui lòng đăng nhập để lưu thiết kế.",
        // showCancelButton: true,
        confirmButtonText: "Đăng nhập",
        // cancelButtonText: "Hủy",
        reverseButtons: true,
        showCloseButton: true,
      });

      if (result.isConfirmed) {
        const canvasStatesToSave = {};
        Object.entries(canvasStates).forEach(([key, state]) => {
          canvasStatesToSave[key] = {
            texts: state.texts || [],
            uploadedImages: (state.uploadedImages || []).map((img) => ({
              ...img,
              src: img.image?.src,
              image: undefined,
              attachType: img.attachType,
              layerKey: img.layerKey,
            })),
            stickers: (state.stickers || []).map((s) => ({
              ...s,
              src: s.image?.src,
              image: undefined,
              attachType: s.attachType,
              layerKey: s.layerKey,
            })),
            layerColorMap: state.layerColorMap || {},
          };
        });

        const tempDesignData = {
          canvasStates: canvasStatesToSave,
          selectedProduct,
          currentAttachType,
          selectedLayerId,
          templateId: selectedProduct?.templateId,
        };

        const jsonBlob = new Blob([JSON.stringify(tempDesignData)], { type: "application/json" });
        const jsonFile = new File([jsonBlob], "tempDesign.json", { type: "application/json" });

        try {
          const { fullUrl } = await uploadTempImage(jsonFile);
          const encodedId = fullUrl.split("/").pop(); // chỉ lấy phần mã hóa
          localStorage.setItem("tempDesignBeforeLogin", encodedId);
        } catch (err) {
          console.error("❌ Upload tempDesign thất bại:", err);
        }

        navigate("/authentication/sign-in");
      }
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.userId;
    if (!userId) return;

    try {
      setShowWatermark(false);
      setIsSaving(true);

      // === Ép render ảnh overlay mặt trước (nếu đang ở mặt manocanh)
      const mannequin = selectedProduct?.attachments?.find((att) => att.attachType === 4);
      if (mannequin) {
        await ensureFocusAndLoadCanvas(mannequin);
      }

      // === B1: Export ảnh tổng hợp
      // const dataUrl = await renderAllSidesToImageUrl(2, 1);
      // const blob = await (await fetch(dataUrl)).blob();
      // const file = new File([blob], `design-${Date.now()}.png`, { type: "image/png" });
      const previousState = {
        texts,
        uploadedImages,
        stickers,
        layerColorMap,
        currentAttachType,
        selectedLayerId,
      };

      const files = await renderAllSidesToFiles({
        pixelRatio: 2,
        quality: 1,
        skipRestore: false,
        selectedProduct,
        layerOptions,
        canvasStates,
        getBaseZoomDataURL,
        handleSetCanvasByLayer,
        waitForCanvasReady,
        saveCurrentCanvasState,
        setTexts,
        setUploadedImages,
        setStickers,
        setLayerColorMap,
        setCurrentAttachType,
        setSelectedLayerId,
        imageMap,
        previousState,
        ensureFocusAndLoadCanvas,
        selectedTextId,
        selectedImageId,
        selectedStickerId,
        resetCanvasState,
      });

      // 👉 Crop từng ảnh sau khi render
      let croppedFiles;
      if (isMobile2)
        croppedFiles = await Promise.all(files.map((file) => cropImageFile(file, 20, false)));
      else
        croppedFiles = await Promise.all(
          files.map((file) => cropImageFile(file, 20, true, 1000, 1400))
        );
      const blob = await fetchPreviewCombinedImage(croppedFiles, true);
      const file = new File([blob], `design-${Date.now()}.png`, { type: "image/png" });

      // === B2: Gọi API tạo CustomerDesign trước
      const design = {
        userId,
        categoryId: selectedCategoryValue,
        templateId: selectedProduct.templateId,
        isActive: 1,
        action: 2,
        id: designToEdit?.id,
      };
      let res;
      if (designToEdit) {
        res = await updateDesignAPI(design, file); // ✅ update
      } else {
        res = await createDesignAPI(design, file); // ✅ create
      }
      if (!res?.success) {
        Swal.fire("Lỗi", "Không thể tạo thiết kế", "error");
        return;
      }
      const customerDesignId = res.data.object.id;

      // === B3: Chuẩn bị dữ liệu TemplateDTO để tạo template riêng
      const templateDTO = new FormData();
      templateDTO.append("templateCode", "");
      templateDTO.append("templateName", selectedProduct.templateName);
      templateDTO.append("categoryId", selectedCategoryValue);
      templateDTO.append("status", 1);
      templateDTO.append("displayOrder", 1);
      templateDTO.append("customerDesignId", customerDesignId);

      // ✅ Convert từng mặt thành preview và đính kèm
      const attachTypes = [
        { type: 1, key: "imageFront" },
        { type: 2, key: "imageBack" },
        { type: 4, key: "imageManocanh" },
      ];

      const itemsToRender = attachTypes
        .map(({ type, key }) => {
          const item = selectedProduct.attachments.find((a) => a.attachType === type);
          return item ? { item, key } : null;
        })
        .filter(Boolean);

      /* eslint-disable no-await-in-loop */
      let i = 0;
      while (i < itemsToRender.length) {
        const { item, key } = itemsToRender[i];
        await ensureFocusAndLoadCanvas(item);
        await waitForCanvasReady();

        // const url = stageRef.current.toDataURL({ pixelRatio: 2, quality: 1 });
        const pixelRatio = 2;
        const quality = 1;
        const url = getBaseZoomDataURL(pixelRatio, quality);

        const imageBlob = await (await fetch(url)).blob();
        const previewFile = new File([imageBlob], `${key}.png`, { type: "image/png" });

        templateDTO.append(key, previewFile);
        i += 1;
      }

      // === B4: Thêm layer DTOs
      const layerFileTasks = layerOptions.map(async (layer, index) => {
        templateDTO.append(`layers[${index}].layerId`, layer.layerId || "");
        templateDTO.append(`layers[${index}].layerCode`, layer.layerCode || "");
        templateDTO.append(`layers[${index}].layerName`, layer.layerName);
        templateDTO.append(`layers[${index}].layerType`, layer.layerType);
        templateDTO.append(`layers[${index}].isColorChange`, layer.isColorChange);
        templateDTO.append(`layers[${index}].displayOrder`, layer.displayOrder || 0);

        // Nếu có file gốc
        if (layer.attachment?.file) {
          templateDTO.append(`layers[${index}].image`, layer.attachment.file);
          return;
        }

        // Nếu có encryptedId => lấy từ imageMap
        const encryptedId = layer.attachment?.encryptedId;
        const url = encryptedId && imageMap[encryptedId];
        if (url) {
          const resLr = await fetch(url);
          const blobLr = await resLr.blob();
          const fileLr = new File([blobLr], `layer-${index}.png`, { type: "image/png" });
          templateDTO.append(`layers[${index}].image`, fileLr);
        }
      });
      await Promise.all(layerFileTasks);

      // ✅ Gom tất cả blob ảnh cần upload
      const allUploadBlobs = []; // blob ảnh từ uploadedImages
      const allStickerBlobs = []; // blob ảnh từ stickers

      const designStates = [];
      const uploadedImageRefs = []; // [{ canvasKey, index, file }]
      const stickerImageRefs = []; // [{ canvasKey, index, file }]

      Object.entries(canvasStates || {}).forEach(([key, state]) => {
        const [attachTypeStr] = key.split("-");
        const attachType = parseInt(attachTypeStr, 10);
        if (!attachType || !selectedProduct?.templateId || !userId) return;

        // Gom ảnh blob uploadedImages
        (state.uploadedImages || []).forEach((img, index) => {
          const src = img.image?.src || img.src;
          if (src?.startsWith("blob:") || src?.startsWith("data:image/")) {
            uploadedImageRefs.push({ canvasKey: key, index });
            allUploadBlobs.push(fetch(src).then((r) => r.blob()));
          }
        });

        // Gom ảnh blob stickers
        (state.stickers || []).forEach((s, index) => {
          const src = s.image?.src || s.src;
          if (src?.startsWith("blob:")) {
            stickerImageRefs.push({ canvasKey: key, index });
            allStickerBlobs.push(fetch(src).then((r) => r.blob()));
          }
        });
      });

      // ✅ Upload tất cả blob ảnh (uploadedImages + stickers)
      // uploadImages blobs
      const isUpdate = !!designToEdit;

      const uploadImageBlobs = await Promise.all(allUploadBlobs);
      const uploadImageFiles = uploadImageBlobs.map(
        (b, idx) => new File([b], `upload-${idx}-${Date.now()}.png`, { type: "image/png" })
      );
      const uploadImageResults = await uploadMultipleDesignAttachments({
        files: uploadImageFiles,
        objectId: customerDesignId,
        objectType: 5,
        attachType: 10,
        isUpdate,
      });

      // sticker blobs
      const stickerImageBlobs = await Promise.all(allStickerBlobs);
      const stickerImageFiles = stickerImageBlobs.map(
        (b, idx) => new File([b], `sticker-${idx}-${Date.now()}.png`, { type: "image/png" })
      );
      const stickerImageResults = await uploadMultipleDesignAttachments({
        files: stickerImageFiles,
        objectId: customerDesignId,
        objectType: 5,
        attachType: 5,
        isUpdate,
      });

      // ✅ Xử lý designStates
      Object.entries(canvasStates || {}).forEach(([key, state]) => {
        const [attachTypeStr] = key.split("-");
        const attachType = parseInt(attachTypeStr, 10);
        if (!attachType || !selectedProduct?.templateId || !userId) return;

        const mappedUploadedImages = (state.uploadedImages || []).map((img, index) => {
          const refIdx = uploadedImageRefs.findIndex(
            (r) => r.canvasKey === key && r.index === index
          );
          return {
            ...img,
            image: undefined,
            src: undefined,
            encryptedId:
              refIdx >= 0
                ? uploadImageResults[refIdx]?.encryptedBase64Id || null
                : img.encryptedId || null,
          };
        });

        const mappedStickers = (state.stickers || []).map((s, index) => {
          const refIdx = stickerImageRefs.findIndex(
            (r) => r.canvasKey === key && r.index === index
          );
          return {
            ...s,
            image: undefined,
            src: undefined,
            encryptedId:
              refIdx >= 0
                ? stickerImageResults[refIdx]?.encryptedBase64Id || null
                : s.encryptedId || null,
          };
        });

        designStates.push({
          customerDesignId,
          attachType,
          texts: JSON.stringify(state.texts || []),
          uploadedImages: JSON.stringify(mappedUploadedImages),
          stickers: JSON.stringify(mappedStickers),
          layerColorMap: JSON.stringify(state.layerColorMap || {}),
          isActive: 1,
        });
      });

      // ✅ Gắn vào FormData gửi kèm tạo template
      templateDTO.append(
        "designStates",
        new File([JSON.stringify(designStates)], "designStates.json", {
          type: "application/json",
        })
      );

      // === B5: Gọi API tạo template + lưu designStates trong 1 transaction
      let templateRes;
      if (designToEdit?.templateId) {
        templateDTO.append("templateId", designToEdit.templateId); // đảm bảo templateId truyền lên
        templateRes = await fetchTemplateUpdate(designToEdit.templateId, templateDTO);
      } else {
        templateRes = await fetchTemplateCreate(templateDTO);
      }

      if (!templateRes.success) {
        Swal.fire("Lỗi", "Không thể lưu sản phẩm thiết kế", "error");
        return;
      }

      Swal.fire("Thành công", "Thiết kế đã được lưu lại tại Thiết kế của tôi", "success");
    } catch (err) {
      console.error("Lỗi khi lưu thiết kế:", err);
      Swal.fire("Lỗi", "Đã có lỗi xảy ra khi lưu thiết kế", "error");
    } finally {
      setIsSaving(false); // ✅ bỏ chặn
      setShowWatermark(true);
    }
  };

  const loadCanvasState = async (product) => {
    if (!designToEdit?.templateId) return;

    const jsonAttachments = designToEdit.attachments?.filter(
      (a) => a.attachType === 11 // ⬅ hoặc Constants.ATTACH_TYPE.DESIGN_STATE_JSON
    );

    if (!jsonAttachments || jsonAttachments.length === 0) return;

    const token = localStorage.getItem("token");

    const firstJson = jsonAttachments[0];
    const url = downloadJsonByEncryptedId(firstJson.encryptedId);

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const blob = await res.blob();
    const jsonText = await blob.text();

    let list = [];

    try {
      const parsed = JSON.parse(jsonText);

      if (!Array.isArray(parsed)) {
        console.warn("❌ File JSON không phải mảng, có thể là lỗi xác thực:", parsed);
        Swal.fire("Lỗi", parsed?.message || "Không thể đọc nội dung file JSON", "error");
        return;
      }

      list = parsed;
    } catch (err) {
      console.warn("❌ Lỗi parse JSON:", err);
      Swal.fire("Lỗi", "File JSON không hợp lệ", "error");
      return;
    }

    const newCanvasStates = {};
    const mergedLayerColorMap = {};

    const loadImages = async (items = []) =>
      Promise.all(
        items.map((item) => {
          const { encryptedId } = item;
          if (!encryptedId) return Promise.resolve({ ...item, image: null });

          const url2 = downloadByEncryptedId(encryptedId);
          return fetch(url2, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res2) => (res2.ok ? res2.blob() : null))
            .then((blob2) => {
              if (!blob2) return { ...item, image: null };
              const blobUrl = URL.createObjectURL(blob2);
              if (encryptedId && blobUrl) {
                setImageMap((prev) => ({
                  ...prev,
                  [encryptedId]: blobUrl,
                }));
              }

              return new Promise((resolve) => {
                const img = new Image();
                img.src = blobUrl;
                img.onload = () =>
                  resolve({
                    ...item,
                    image: img,
                    src: blobUrl,
                    width: item.width || img.width,
                    height: item.height || img.height,
                  });
                img.onerror = () => resolve({ ...item, image: null });
              });
            })
            .catch(() => ({ ...item, image: null }));
        })
      );

    await Promise.all(
      list.map(async (stateItem) => {
        try {
          const parsedTexts = JSON.parse(stateItem.texts || "[]");
          const parsedUploadedImagesRaw = JSON.parse(stateItem.uploadedImages || "[]");
          const parsedStickersRaw = JSON.parse(stateItem.stickers || "[]");
          const parsedLayerColorMap = JSON.parse(stateItem.layerColorMap || "{}");

          const loadedUploadedImages = await loadImages(parsedUploadedImagesRaw);
          const loadedStickers = await loadImages(parsedStickersRaw);

          // ✅ Lấy tất cả layerKey từ các phần tử đang có
          const allLayerKeys = [
            ...new Set([
              ...parsedTexts.map((t) => t.layerKey),
              ...loadedUploadedImages.map((u) => u.layerKey),
              ...loadedStickers.map((s) => s.layerKey),
              ...Object.keys(parsedLayerColorMap),
            ]),
          ].filter(Boolean);

          // Gán attachType trước
          parsedTexts.forEach((t) => {
            t.attachType = stateItem.attachType;
          });
          loadedUploadedImages.forEach((img) => {
            img.attachType = stateItem.attachType;
          });
          loadedStickers.forEach((s) => {
            s.attachType = stateItem.attachType;
          });

          // ✅ Mỗi layerKey có một canvasState riêng
          allLayerKeys.forEach((layerKey) => {
            const textsForLayer = parsedTexts.filter((t) => t.layerKey === layerKey || !t.layerKey);
            const uploadsForLayer = loadedUploadedImages.filter(
              (u) => u.layerKey === layerKey || !u.layerKey
            );
            const stickersForLayer = loadedStickers.filter(
              (s) => s.layerKey === layerKey || !s.layerKey
            );

            // Only update newCanvasStates if there’s data to store
            if (
              textsForLayer.length > 0 ||
              uploadsForLayer.length > 0 ||
              stickersForLayer.length > 0 ||
              parsedLayerColorMap[layerKey]
            ) {
              // 👇 Gộp vào key đã có thay vì ghi đè
              if (!newCanvasStates[layerKey]) {
                newCanvasStates[layerKey] = {
                  texts: [],
                  uploadedImages: [],
                  stickers: [],
                  layerColorMap: {},
                };
              }

              textsForLayer.forEach((t) => {
                t.layerKey = layerKey;
              });
              uploadsForLayer.forEach((u) => {
                u.layerKey = layerKey;
              });
              stickersForLayer.forEach((s) => {
                s.layerKey = layerKey;
              });

              newCanvasStates[layerKey].texts.push(...textsForLayer);
              newCanvasStates[layerKey].uploadedImages.push(...uploadsForLayer);
              newCanvasStates[layerKey].stickers.push(...stickersForLayer);

              if (parsedLayerColorMap[layerKey]) {
                newCanvasStates[layerKey].layerColorMap[layerKey] = parsedLayerColorMap[layerKey];
                mergedLayerColorMap[layerKey] = parsedLayerColorMap[layerKey];
              }
            }
          });

          // Object.entries(parsedLayerColorMap).forEach(([layerKey, color]) => {
          //   const textsForLayer = parsedTexts.filter((t) => t.layerKey === layerKey);
          //   const uploadsForLayer = loadedUploadedImages.filter((u) => u.layerKey === layerKey);
          //   const stickersForLayer = loadedStickers.filter((s) => s.layerKey === layerKey); // giờ đã có layerKey

          //   newCanvasStates[layerKey] = {
          //     texts: textsForLayer,
          //     uploadedImages: uploadsForLayer,
          //     stickers: stickersForLayer,
          //     layerColorMap: {
          //       [layerKey]: color,
          //     },
          //   };

          //   mergedLayerColorMap[layerKey] = color;
          // });
        } catch (err) {
          console.warn("⚠️ Lỗi parse canvasState từ file:", err);
        }
      })
    );

    setCanvasStates(newCanvasStates);
    setLayerColorMap(mergedLayerColorMap);

    const attachTypeWithSticker = list.find((item) => {
      const stickers2 = JSON.parse(item.stickers || "[]");
      return stickers2.length > 0;
    })?.attachType;

    const firstAttach = product.attachments?.find((a) => a.attachType === attachTypeWithSticker);

    if (firstAttach) {
      try {
        await waitUntilImageAvailable(firstAttach.encryptedId);
        await handleSetCanvasByLayer(firstAttach, {
          skipReset: false,
          canvasStatesOverride: newCanvasStates,
        });
      } catch (err) {
        console.warn("Lỗi khi set canvas sau restore:", err);
      }
    }
  };

  useEffect(() => {
    if (!designToEdit?.templateId) return;

    const savedUrl = sessionStorage.getItem("designToPendingAfterLogin");
    if (designToEdit && savedUrl) {
      sessionStorage.removeItem("designToPendingAfterLogin");
    }

    const loadProductToEdit = async () => {
      const found = await fetchTemplateById(designToEdit.templateId);
      if (found) {
        setSelectedProduct(found);
        setIsRestoringEdit(true); // ✅ bật flag chờ load layerOptions
      }
    };

    loadProductToEdit();
  }, [designToEdit]);

  useEffect(() => {
    if (!isRestoringEdit || !selectedProduct || !layerReady) return;

    const runRestore = async () => {
      await loadCanvasState(selectedProduct);

      // ❌ Đừng gọi lại handleSetCanvasByLayer lần 2
      // vì loadCanvasState đã làm rồi
      setIsRestoringEdit(false);
    };

    runRestore();
  }, [isRestoringEdit, selectedProduct, layerReady]);

  const handlePreviewDesign = async () => {
    try {
      setShowWatermark(false);
      setIsGeneratingPreview(true);

      // 👉 Ép render manocanh để sinh ảnh overlay mặt trước
      const mannequin = selectedProduct?.attachments?.find((att) => att.attachType === 4);
      if (mannequin) {
        await ensureFocusAndLoadCanvas(mannequin);
      }

      const previousState = {
        texts,
        uploadedImages,
        stickers,
        layerColorMap,
        currentAttachType,
        selectedLayerId,
      };

      const files = await renderAllSidesToFiles({
        pixelRatio: 2,
        quality: 1,
        skipRestore: false,
        selectedProduct,
        layerOptions,
        canvasStates,
        getBaseZoomDataURL,
        handleSetCanvasByLayer,
        waitForCanvasReady,
        saveCurrentCanvasState,
        setTexts,
        setUploadedImages,
        setStickers,
        setLayerColorMap,
        setCurrentAttachType,
        setSelectedLayerId,
        imageMap,
        previousState,
        ensureFocusAndLoadCanvas,
        selectedTextId,
        selectedImageId,
        selectedStickerId,
        resetCanvasState,
      });

      // files.forEach((file) => {
      //   const url = URL.createObjectURL(file);
      //   window.open(url, "_blank");
      // });

      // 👉 Crop từng ảnh sau khi render
      let croppedFiles;
      if (isMobile2)
        croppedFiles = await Promise.all(files.map((file) => cropImageFile(file, 20, false)));
      else
        croppedFiles = await Promise.all(
          files.map((file) => cropImageFile(file, 20, true, 1000, 1400))
        );

      // croppedFiles.forEach((file) => {
      //   const url = URL.createObjectURL(file);
      //   window.open(url, "_blank");
      // });

      const blob = await fetchPreviewCombinedImage(croppedFiles, true);
      const url = URL.createObjectURL(blob);

      setPreviewImages([{ label: "Xem trước thiết kế", imageUrl: url }]);
      setPreviewModalOpen(true);
    } catch (err) {
      Swal.fire("Lỗi", "Không thể tạo ảnh xem trước từ server", "error");
    } finally {
      setIsGeneratingPreview(false);
      setShowWatermark(true);
    }
  };

  const isTextFacingDown = (rotation = 0) => {
    const normalized = ((rotation % 360) + 360) % 360; // về khoảng 0-360
    return normalized > 90 && normalized < 270;
  };

  useEffect(() => {
    const transformer = transformerRef.current;

    let node = null;
    if (selectedTextId) {
      node = stageRef.current.findOne(`#${selectedTextId}`);
    } else if (selectedImageId) {
      node = uploadImageRefs.current[selectedImageId];
    } else if (selectedStickerId) {
      node = stickerRefs.current[selectedStickerId];
    }

    if (transformer && node) {
      transformer.nodes([node]);
      setTimeout(() => transformer.getLayer().batchDraw(), 0);
    } else {
      transformer?.nodes([]);
    }
  }, [selectedTextId, selectedImageId, selectedStickerId, stickers, uploadedImages]);

  useEffect(() => {
    if (isResetting) return;

    const highlightId = filteredLayerOptions?.[0]?.layerId;
    if (highlightImage && highlightId) {
      applyHighlightFilter(highlightId);
    }
  }, [highlightImage, layerColorMap, currentAttachType, selectedLayerId]);

  useEffect(() => {
    if (isResetting) return;
    if (!currentAttachType || !overlayLayers.length || !layerColorMap) return;

    overlayLayers.forEach((layer, idx) => {
      const key = `${currentAttachType}-${layer.layerId}`;
      const hex = layerColorMap[key];
      if (!hex) return;

      const ref = overlayKonvaRefs.current[idx];
      if (!ref) return;

      const rgba = hexToRGBA(hex);
      ref.cache();
      ref.filters([Konva.Filters.RGBA]);
      ref.red(rgba.r);
      ref.green(rgba.g);
      ref.blue(rgba.b);
      ref.alpha(1);
      ref.getLayer()?.batchDraw();
    });
  }, [overlayLayers, layerColorMap, currentAttachType]);

  useEffect(() => {
    if (!designToPending) return;

    const restoredCanvasStates = designToPending.canvasStates || {};
    const attachType = designToPending.currentAttachType;
    const layerId = designToPending.selectedLayerId;
    const keyold = `${attachType}-${layerId}`;

    const state = restoredCanvasStates[keyold] || {};

    setTexts(state.texts || []);
    setUploadedImages(state.uploadedImages || []);
    setStickers(state.stickers || []);
    setLayerColorMap(state.layerColorMap || {});
    setCurrentAttachType(attachType || null);
    setSelectedLayerId(layerId || null);
    setSelectedProduct(designToPending.selectedProduct || null);

    setCanvasStates(restoredCanvasStates);
  }, [designToPending]);

  useEffect(() => {
    if (selectedTextId) {
      const selectedText = texts.find((t) => t.id === selectedTextId);
      if (!selectedText.isCurved) {
        const newWidth = calculateTextWidth(
          selectedText.text,
          selectedText.fontSize,
          selectedText.fontFamily
        );
        setTexts((prev) =>
          prev.map((t) =>
            t.id === selectedTextId
              ? { ...t, width: Math.max(newWidth, 50) } // ✅ Không touch align
              : t
          )
        );
      }
    }
  }, [selectedTextId, texts]);

  const flipImageHorizontally = async (originalImage) => {
    if (!originalImage) return null;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = originalImage.width;
    canvas.height = originalImage.height;

    // Lật ngang ảnh
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(originalImage, 0, 0);

    return new Promise((resolve) => {
      const flippedImg = new Image();
      flippedImg.onload = () => resolve(flippedImg);
      flippedImg.src = canvas.toDataURL("image/png");
    });
  };

  useEffect(() => {
    const initCategoryWithProducts = async () => {
      const categories = await fetchCategoryOptions();
      setCategoryOptions(categories);

      // ✅ Luôn fetch tất cả sản phẩm từng danh mục
      const results = await Promise.all(
        categories.map((cat) =>
          fetchProductsByCategory(cat.value, 0, 10, "").then((res) => ({
            category: cat,
            res,
          }))
        )
      );

      // ✅ Nếu có designToPending → tìm lại danh mục chứa selectedProduct của nó
      let firstProduct = null;
      let category = null;
      let res = null;

      if (designToPending?.selectedProduct?.categoryId) {
        const matched = results.find(
          (r) => r.category.value === designToPending.selectedProduct.categoryId
        );
        if (matched) {
          category = matched.category;
          res = matched.res;
          firstProduct = res.datas.find(
            (p) => p.templateId === designToPending.selectedProduct.templateId
          );
        }
      }

      // ✅ Nếu không có designToPending hoặc không khớp → dùng danh mục đầu tiên có sản phẩm
      if (!firstProduct) {
        const fallback = results.find((r) => r.res?.datas?.length > 0);
        if (fallback) {
          ({ category, res } = fallback);
          [firstProduct] = res.datas;
        }
      }

      // ✅ Luôn gán danh sách để hiển thị
      setSelectedCategoryValue(category.value);
      setProductList(res.datas);
      setTemplateTotal(res.totals);

      if (!designToEdit) {
        // if (designToPending) {
        //   console.log("✅ Khôi phục từ thiết kế tạm sau login");

        //   const restoredCanvasStates = designToPending.canvasStates || {};
        //   const attachType = designToPending.currentAttachType;
        //   const layerId = designToPending.selectedLayerId;
        //   const key = `${attachType}-${layerId}`;
        //   const state = restoredCanvasStates[key] || {};

        //   setTexts(state.texts || []);
        //   setLayerColorMap(state.layerColorMap || {});
        //   setCurrentAttachType(attachType || null);
        //   setSelectedLayerId(layerId || null);
        //   setSelectedProduct(designToPending.selectedProduct || firstProduct);
        //   setCanvasStates(restoredCanvasStates); // Gán toàn bộ lại để xử lý sau

        //   const loadImages = async (items = [], setState) => {
        //     const loaded = await Promise.all(
        //       items.map(
        //         (item) =>
        //           new Promise((resolve) => {
        //             const img = new Image();
        //             img.onload = () => resolve({ ...item, image: img });
        //             img.onerror = () => {
        //               console.warn("❌ Không tải được ảnh:", item.src);
        //               resolve(null); // ⚠️ bỏ qua ảnh hỏng
        //             };
        //             img.src = item.src;
        //           })
        //       )
        //     );
        //     // ✅ Lọc bỏ những ảnh null hoặc lỗi
        //     setState(loaded.filter(Boolean));
        //   };

        //   // Gọi:
        //   loadImages(state.uploadedImages || [], setUploadedImages);
        //   loadImages(state.stickers || [], setStickers);

        //   sessionStorage.removeItem("designToPendingAfterLogin");
        // }

        // ✅ Nếu không có gì đang chỉnh sửa → dùng firstProduct như bình thường
        setSelectedProduct(firstProduct);

        const firstAttach = firstProduct.attachments?.find((a) => [1, 2, 4].includes(a.attachType));

        if (firstAttach?.encryptedId) {
          const checkInterval = setInterval(() => {
            const url = imageMap[firstAttach.encryptedId];
            if (url) {
              clearInterval(checkInterval);
              ensureFocusAndLoadCanvas(firstAttach);
            }
          }, 100);

          setTimeout(() => clearInterval(checkInterval), 2000);
        }
      }
    };

    initCategoryWithProducts();
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      if (canvasContainerRef.current?.contains(e.target)) {
        e.preventDefault(); // chỉ chặn nếu chuột phải trong canvas
      }
    };
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "PrintScreen") {
        if (canvasContainerRef.current) {
          canvasContainerRef.current.style.filter = "blur(8px)";
          setTimeout(() => {
            canvasContainerRef.current.style.filter = "none";
          }, 1000);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const createDragBoundFunc = (width, height) => (pos) => {
    const scaledWidth = width;
    const scaledHeight = height;

    // Tính toán giới hạn dựa trên canvas size và zoom
    const minX = -scaledWidth / 2;
    const maxX = canvasWidth - scaledWidth / 2;
    const minY = -scaledHeight / 2;
    const maxY = canvasHeight - scaledHeight / 2;

    return {
      x: Math.max(minX, Math.min(maxX, pos.x)),
      y: Math.max(minY, Math.min(maxY, pos.y)),
    };
  };

  // const createTextDragBoundFunc = (text) => (pos) => {
  //   const { width: canvasW, height: canvasH } = getZoomAdjustedCanvas();

  //   const width = text.width || 100;
  //   const height = text.fontSize || 30;

  //   const offsetX = width / 2;
  //   const offsetY = height / 2;
  //   const padding = 50;

  //   const minX = offsetX + padding;
  //   const maxX = canvasW - offsetX - padding;
  //   const minY = offsetY + padding;
  //   const maxY = canvasH - offsetY - padding;

  //   return {
  //     x: Math.max(minX, Math.min(pos.x, maxX)),
  //     y: Math.max(minY, Math.min(pos.y, maxY)),
  //   };
  // };

  return (
    <>
      <Box
        sx={{
          py: 6,
          background: "linear-gradient(135deg, #0d1b2a 0%, #7a3d42 40%, #27496d 100%)",
          minHeight: "100vh",
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            px: 2,
            maxWidth: "1500px !important",
            overflowX: "hidden", // ❌ bỏ auto ngang ở đây
            overflowY: "hidden",
            width: "100%", // ✅ dùng width thay vì minWidth
            boxSizing: "border-box", // ✅ tránh tràn do padding
          }}
        >
          <Box
            sx={{
              overflowY: { xs: "auto", sm: "hidden" }, // 👈 Cho phép cuộn dọc trên mobile
              borderRadius: 3,
              flexDirection: { xs: "column", md: "row" },
              backgroundColor: "white",
              minHeight: { xs: "calc(100vh - 64px)", sm: 500, md: 950 }, // 👈 Dùng minHeight, trừ header/footer
              height: { sm: 500, md: 950 }, // 👈 Chỉ đặt height cố định cho sm/md
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
              width: "100%",
              overflowX: { xs: "hidden", sm: "auto" },
              boxSizing: "border-box", // 👈 Thêm để đảm bảo tính toán kích thước đúng
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                flex: 1, // 👈 Chiếm toàn bộ không gian cha
                minHeight: { xs: canvasHeight || "auto", sm: "auto", md: "auto" }, // 👈 Đồng bộ với canvasHeight trên xs
                backgroundColor: "white",
                borderRadius: 3,
                justifyContent: { xs: "center", sm: "flex-start", md: "center" },
                overflowX: { xs: "hidden", sm: "auto" },
                overflowY: { xs: "auto", sm: "hidden" }, // 👈 Cho phép cuộn dọc trên mobile
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* body 1 */}
              <Box
                sx={{
                  order: { xs: 1, md: 0 },
                  width: { xs: "100%", sm: 90, md: 100 },
                  minWidth: { xs: "100%", sm: 90, md: 100 },
                  height: { xs: 60, md: "100%" },
                  flexShrink: 0,
                  backgroundColor: "#fff",
                  borderRight: { md: "1px solid #ddd" },
                  borderBottom: { xs: "1px solid #ddd", md: "none" },
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderTopLeftRadius: { md: 12 },
                  borderBottomLeftRadius: { md: 12 },
                  borderTopRightRadius: { xs: 12, md: 0 },
                  borderBottomRightRadius: { xs: 12, md: 0 },
                }}
              >
                <SidebarMenu
                  onAction={setSelectedTool}
                  onDownload={handleExportImage}
                  onShare={handleShareToFacebook}
                  onSave={handleSaveDesign}
                  direction={isMobile ? "row" : "column"}
                />
              </Box>

              {/* body 2 */}
              <Box
                sx={{
                  order: { xs: 2, md: 1 },
                  flexBasis: { xs: "100%", sm: 190, lg: isTablet ? 240 : 450 },
                  maxWidth: { xs: "100%", sm: 190, lg: isTablet ? 240 : 450 },
                  minWidth: { xs: 0, sm: 190, lg: isTablet ? 240 : 450 },
                  flexShrink: 0,
                  flexGrow: { xs: 0, md: 1 }, // 👈 Ngăn mở rộng quá mức trên mobile
                  backgroundColor: "#fff",
                  p: 2,
                  borderRight: { md: "1px solid #ddd", xs: "none" },
                  position: "relative",
                  minHeight: { xs: canvasHeight || 360, sm: 400, md: "100%" }, // 👈 Đồng bộ với canvasHeight trên xs
                  maxHeight: { xs: "50vh", sm: "60vh", md: "none" }, // 👈 Giới hạn chặt chẽ trên mobile
                  overflowY: { xs: "auto", md: "visible" },
                  display: "flex",
                  flexDirection: "column",
                  scrollbarWidth: { xs: "none" }, // 👈 Ẩn thanh cuộn trên mobile
                  "&::-webkit-scrollbar": { display: "none" }, // 👈 Ẩn thanh cuộn trên Chrome/Safari
                }}
              >
                {selectedTool === "product" && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    {/* 🔍 Thanh tìm kiếm sản phẩm */}
                    <Box display="flex" gap={1} mb={2}>
                      <TextField
                        fullWidth
                        placeholder="Tìm kiếm mẫu sản phẩm"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setProductList([]);
                            setTemplatePage(0);
                            fetchProductsByCategory(selectedCategoryValue, 0, 10, searchText).then(
                              (res) => {
                                setProductList(res.datas);
                                setTemplateTotal(res.totals);
                              }
                            );
                          }
                        }}
                        variant="outlined"
                        size="small"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px !important",
                          },
                          "& input": {
                            fontSize: "14px",
                            padding: "10px 8px",
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon
                                sx={{
                                  fontSize: 24,
                                  color: "#888",
                                  cursor: "pointer",
                                  "&:hover": {
                                    color: "#555",
                                  },
                                }}
                                onClick={() => {
                                  setProductList([]);
                                  setTemplatePage(0);
                                  fetchProductsByCategory(
                                    selectedCategoryValue,
                                    0,
                                    10,
                                    searchText
                                  ).then((res) => {
                                    setProductList(res.datas);
                                    setTemplateTotal(res.totals);
                                  });
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>

                    {/* 🧭 Layer Navigator (danh mục) */}
                    {selectedCategoryValue != null && (
                      <Box flexGrow={1} width="100%" maxHeight={50}>
                        <LayerNavigator
                          layers={categoryOptions.map((opt) => ({
                            id: opt.value,
                            label: opt.label,
                          }))}
                          selectedId={selectedCategoryValue}
                          onSelect={(value) => {
                            const index = categoryOptions.findIndex((opt) => opt.value === value);
                            if (index !== -1) {
                              setSelectedCategoryValue(value);
                            }
                          }}
                          visibleCount={4}
                        />
                      </Box>
                    )}

                    {/* 🎯 Danh sách cuộn */}
                    <Typography fontWeight="bold" fontSize={16}>
                      Tất cả kết quả
                    </Typography>
                    <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2 }}>
                      <Grid container spacing={1}>
                        {productList.map((template, i) => {
                          const imgUrl = getFrontImageUrl(template);
                          return (
                            <Grid item xs={6} key={i}>
                              <Box textAlign="center">
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mb: 1,
                                    pt: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      minHeight: {
                                        xs: 100, // ✅ giảm kích thước ảnh ở mobile
                                        sm: 130,
                                        md: 160,
                                      },
                                      width: "100%", // thay vì width: 200
                                      maxWidth: {
                                        xs: 100, // ✅ giảm kích thước ảnh ở mobile
                                        sm: 130,
                                        md: 160,
                                      },
                                      aspectRatio: "1 / 1",
                                      borderRadius: 2,
                                      border:
                                        selectedProduct?.templateId === template.templateId
                                          ? "2px solid #1976d2"
                                          : "1px solid #C7C9CB",
                                      boxShadow:
                                        selectedProduct?.templateId === template.templateId
                                          ? "0 0 6px rgba(25, 118, 210, 0.6)"
                                          : "none",
                                      overflow: "hidden",
                                      backgroundColor: "#f5f5f5",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition:
                                        "transform 0.3s ease, filter 0.3s ease, border 0.3s",
                                      cursor: "pointer",
                                      "&:hover": {
                                        transform: "scale(1.03)",
                                      },
                                    }}
                                    onClick={() => {
                                      const defaultAttach = template.attachments?.[0];
                                      if (!defaultAttach || !imageMap[defaultAttach.encryptedId])
                                        return;

                                      if (selectedProduct?.templateId === template.templateId) {
                                        const firstAttach = template.attachments?.find((a) =>
                                          [1, 2, 4].includes(a.attachType)
                                        );
                                        if (firstAttach) ensureFocusAndLoadCanvas(firstAttach);
                                        return;
                                      }

                                      // Reset toàn bộ
                                      setDesignToEdit(null);
                                      setIsRestoringEdit(false);
                                      navigate("/", { replace: true });
                                      setCanvasStates({});
                                      setTexts([]);
                                      setUploadedImages([]);
                                      setStickers([]);
                                      setLayerColorMap({});
                                      setSelectedLayerId(null);
                                      setCurrentAttachType(null);
                                      setOverlayLayers([]);
                                      setHighlightImage(null);
                                      overlayKonvaRefs.current = [];
                                      highlightImageRef.current = null;

                                      setLayerOptions([]);
                                      setSelectedProduct(template);
                                    }}
                                  >
                                    {imgUrl ? (
                                      <img
                                        src={imgUrl}
                                        alt=""
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "gray",
                                          fontSize: 14,
                                        }}
                                      >
                                        Không có ảnh
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                                <Typography fontSize={16}>{template.templateName}</Typography>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>

                      {productList.length < templateTotal && (
                        <Box mt={1} textAlign="center">
                          <Button variant="outlined" onClick={loadMoreTemplates}>
                            Xem thêm
                          </Button>
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        width: "100%", // đảm bảo không bị co lại trong flex container
                        flexShrink: 0, // không bị thu nhỏ khi flex
                        mt: 2,
                        px: 2,
                        py: 1,
                        backgroundColor: "#fafafa",
                        borderTop: "1px solid #ddd",

                        // Responsive font + khoảng cách
                        "& .MuiTypography-root": {
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          lineHeight: { xs: 1.3, md: 1.6 }, // ✅ dòng ngắn hơn ở mobile
                          mb: { xs: 0.25, md: 0.5 }, // ✅ khoảng cách dưới nhỏ hơn ở mobile
                        },

                        "& ul": {
                          pl: "1rem",
                          mt: 1,
                          mb: 0,
                        },

                        "& li": {
                          padding: 0,
                          margin: 0,
                          mb: { xs: "2px", md: "6px" }, // ✅ giữa các dòng li gần hơn ở xs
                          lineHeight: { xs: 0.5, md: 1.6 },
                        },
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                            Lưu ý:
                          </Typography>
                          <ul>
                            <li>
                              <Typography variant="body2">
                                Thiết kế chỉ mang tính chất tham khảo
                              </Typography>
                            </li>
                            <li>
                              <Typography variant="body2">
                                Nếu bạn cần mẫu thiết kế chi tiết, vui lòng{" "}
                                <Link
                                  href="http://zalo.me/0932087770"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  underline="none"
                                  sx={{
                                    fontWeight: 500,
                                    color: "inherit",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                      textDecoration: "underline",
                                      fontWeight: "bold",
                                    },
                                  }}
                                >
                                  liên hệ đồng phục Zumi
                                </Link>{" "}
                                để được hỗ trợ
                              </Typography>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                )}

                {selectedTool === "sticker" && (
                  <>
                    {/* 🔒 Thanh tìm kiếm cố định */}
                    <Box display="flex" gap={1} mb={2}>
                      <TextField
                        fullWidth
                        placeholder="Tìm kiếm sticker"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            fetchStickers({ page: 0, size: 10, searchString: searchText }).then(
                              (res) => {
                                setStickerList(res.datas);
                                setStickerTotal(res.totals);
                                setStickerPage(0);
                              }
                            );
                          }
                        }}
                        variant="outlined"
                        size="small"
                        sx={{
                          mb: 0,
                          "& .MuiInputBase-root": {
                            height: "40px !important",
                          },
                          "& input": {
                            fontSize: "14px",
                            padding: "10px 8px",
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon
                                sx={{
                                  fontSize: 24,
                                  color: "#888",
                                  cursor: "pointer",
                                  "&:hover": {
                                    color: "#555",
                                  },
                                }}
                                onClick={() => {
                                  fetchStickers({ page: 0, size: 10, searchText }).then((res) => {
                                    setStickerList(res.datas);
                                    setStickerTotal(res.totals);
                                    setStickerPage(0);
                                  });
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>

                    {/* ✅ Danh sách sticker có scroll */}
                    <Typography fontWeight="bold" fontSize={16}>
                      Tất cả sticker
                    </Typography>
                    <Box
                      sx={{
                        flex: 1,
                        overflowY: "auto",
                        pr: 1,
                        mt: 2,
                      }}
                    >
                      <Grid container spacing={1}>
                        {stickerList.map((sticker, i) => {
                          const encryptedId = sticker?.attachment?.encryptedId;
                          const imgUrl = imageMap[encryptedId];

                          return (
                            <Grid item xs={6} key={i}>
                              <Box
                                textAlign="center"
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 1,
                                  pt: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: "100%",
                                    maxWidth: {
                                      xs: 100,
                                      sm: 130,
                                      md: 160,
                                    },
                                    aspectRatio: "1 / 1",
                                    borderRadius: 2,
                                    border: "1px solid #C7C9CB",
                                    backgroundColor: "#f5f5f5",
                                    overflow: "hidden",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    transition:
                                      "transform 0.3s ease, filter 0.3s ease, border 0.3s",
                                    cursor: "grab",
                                    "&:hover": {
                                      border: "2px solid #1976d2",
                                      boxShadow: "0 0 6px rgba(25, 118, 210, 0.6)",
                                      transform: "scale(1.03)",
                                    },
                                  }}
                                >
                                  {imgUrl ? (
                                    <img
                                      src={imgUrl}
                                      alt={sticker.stickerName}
                                      draggable
                                      onDragStart={(e) => {
                                        e.dataTransfer.setData("application/sticker-src", imgUrl);
                                        e.dataTransfer.effectAllowed = "copy";
                                        e.dataTransfer.dropEffect = "copy";
                                      }}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        cursor: "grab",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "gray",
                                        fontSize: 14,
                                      }}
                                    >
                                      Không có ảnh
                                    </Box>
                                  )}
                                </Box>
                                <Typography fontSize={14} textAlign="center">
                                  {sticker.stickerName}
                                </Typography>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>

                      {stickerList.length < stickerTotal && (
                        <Box mt={1} textAlign="center">
                          <Button variant="outlined" onClick={loadMoreStickers}>
                            Xem thêm
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </>
                )}

                {selectedTool === "text" && (
                  <Box ref={colorPickerRef} sx={{ position: "relative", mt: 2 }}>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        mb={1}
                        sx={{ fontSize: "16px", fontWeight: "Bold" }}
                      >
                        Thêm văn bản
                      </Typography>

                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <Typography variant="caption" sx={{ fontSize: "16px" }}>
                          Chọn màu mặc định:
                        </Typography>

                        <Box
                          ref={defaultColorButtonRef}
                          onClick={(e) => {
                            const buttonRect = e.currentTarget.getBoundingClientRect();
                            const containerRect = colorPickerRef.current?.getBoundingClientRect();

                            if (containerRect) {
                              setDefaultColorPickerPosition({
                                top: buttonRect.bottom - containerRect.top + 4, // 4px margin dưới
                                left: buttonRect.left - containerRect.left,
                              });
                              setShowDefaultColorPicker(true);
                            }
                          }}
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            backgroundColor: defaultTextColor,
                            cursor: "pointer",
                            boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
                          }}
                        />
                      </Box>

                      <textarea
                        rows={3}
                        placeholder="Nhập nội dung"
                        style={{
                          width: "100%",
                          padding: "10px",
                          fontSize: "16px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          resize: "vertical",
                          outline: "none",
                          marginBottom: "12px",
                        }}
                        value={textInput}
                        onChange={(e) => setTextInput(e.target.value)}
                      />

                      <Button
                        variant="contained"
                        fullWidth
                        sx={{
                          backgroundColor: "#00A9FF",
                          textTransform: "none",
                          fontWeight: "bold",
                          borderRadius: "6px",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "#008CDB",
                          },
                        }}
                        onClick={() => {
                          if (isMannequinSelected) return;
                          if (textInput.trim()) {
                            increaseActionCount();
                            pushUndoSnapshot();
                            addTextToCanvas(textInput.trim());
                            setTextInput("");
                          }
                        }}
                      >
                        <Typography fontSize={16} fontWeight="bold">
                          Thêm Text
                        </Typography>
                      </Button>
                      {/* DANH SÁCH TEXT CÓ SCROLL */}
                      <Box
                        sx={{
                          flex: 1,
                          overflowY: "auto",
                          pr: 1,
                          mt: 2,
                          maxHeight: {
                            xs: "20vh", // giới hạn chiều cao ở mobile
                            sm: "30vh", // tablet
                            md: "40vh", // desktop
                          },
                          minHeight: 0, // chống tràn con
                        }}
                      >
                        <Typography fontWeight="bold" fontSize={16}>
                          Danh sách văn bản đã thêm
                        </Typography>

                        {texts
                          .filter((t) => t.attachType === currentAttachType)
                          .map((text) => (
                            <Box
                              key={text.id}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              px={2}
                              py={1}
                              mb={1}
                              sx={{
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                backgroundColor: selectedTextId === text.id ? "#E3F2FD" : "#f9f9f9",
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: "#E3F2FD",
                                },
                              }}
                              onClick={() => {
                                setSelectedTextId(text.id);
                                setSelectedImageId(null);
                                setSelectedStickerId(null);
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "180px",
                                }}
                              >
                                {text.text}
                              </Typography>

                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // Lưu snapshot trước khi xóa
                                  pushUndoSnapshot();
                                  // Xóa văn bản khỏi state
                                  setTexts((prev) => prev.filter((t) => t.id !== text.id));
                                  // Xóa node khỏi stage
                                  if (stageRef.current) {
                                    const node = stageRef.current.findOne(`#${text.id}`);
                                    if (node) {
                                      node.destroy();
                                      stageRef.current.batchDraw();
                                    }
                                  }
                                  // Xóa tham chiếu trong textRefs
                                  if (textRefs.current[text.id]) {
                                    delete textRefs.current[text.id];
                                  }
                                  // Làm sạch Transformer
                                  if (transformerRef.current) {
                                    transformerRef.current.nodes([]);
                                    transformerRef.current.getLayer()?.batchDraw();
                                  }
                                  // Đặt lại selectedTextId nếu cần
                                  if (selectedTextId === text.id) {
                                    setSelectedTextId(null);
                                  }
                                  // Cập nhật canvasStates
                                  if (currentAttachType && selectedLayerId) {
                                    const key = `${currentAttachType}-${selectedLayerId}`;
                                    setCanvasStates((prev) => ({
                                      ...prev,
                                      [key]: {
                                        ...prev[key],
                                        texts:
                                          prev[key]?.texts?.filter((t) => t.id !== text.id) || [],
                                      },
                                    }));
                                  }
                                }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Box>
                          ))}
                      </Box>
                      {texts.map((text) => {
                        if (
                          !text.layerKey ||
                          text.layerKey !== `${currentAttachType}-${selectedLayerId}`
                        ) {
                          return null;
                        }
                        return text.isCurved ? (
                          <Group
                            key={text.id}
                            draggable
                            x={text.x}
                            y={text.y}
                            onClick={() => setSelectedTextId(text.id)}
                            onDragEnd={(e) => {
                              pushUndoSnapshot(); // Lưu trạng thái trước khi di chuyển
                              const { x, y: dragY } = e.target.position();
                              setTexts((prev) =>
                                prev.map((item) =>
                                  item.id === text.id ? { ...item, x, y: dragY } : item
                                )
                              );
                            }}
                          >
                            {renderCurvedMultilineText({
                              text: text.text,
                              cx: text.x,
                              cy: text.y,
                              radius: text.arcRadius || 150,
                              lineSpacing: text.lineSpacing || 40,
                              fontSize: text.fontSize,
                              fill: text.fill,
                              fontFamily: text.fontFamily,
                              idPrefix: text.id,
                              arcDirection: text.arcDirection || "down",
                              rotation: text.rotation || 0,
                              providedWidth: text.width, // Truyền width
                              providedHeight: text.height, // Truyền height
                            })}
                          </Group>
                        ) : (
                          <Group
                            key={text.id}
                            draggable
                            x={text.x}
                            y={text.y}
                            onClick={() => setSelectedTextId(text.id)}
                            onDragEnd={(e) => {
                              pushUndoSnapshot(); // Lưu trạng thái trước khi di chuyển
                              const { x, y: dragY } = e.target.position();
                              setTexts((prev) =>
                                prev.map((item) =>
                                  item.id === text.id ? { ...item, x, y: dragY } : item
                                )
                              );
                            }}
                          >
                            <Text
                              id={text.id}
                              ref={(node) => {
                                if (node) {
                                  textRefs.current[text.id] = node;
                                } else {
                                  delete textRefs.current[text.id];
                                }
                              }}
                              text={text.text}
                              width={text.width || 300}
                              align={text.align || "left"}
                              wrap="char"
                              fontSize={text.fontSize}
                              fill={text.fill}
                              rotation={text.rotation || 0}
                              fontFamily={text.fontFamily || "Arial"}
                              fontStyle={text.fontStyle || "normal"}
                              textDecoration={text.textDecoration || "none"}
                              onTransformEnd={(e) => {
                                pushUndoSnapshot(); // Lưu trạng thái trước khi transform
                                const node = e.target;
                                const scaleY = node.scaleY();
                                const newFontSize = text.fontSize * scaleY;

                                node.scaleX(1);
                                node.scaleY(1);
                                node.fontSize(newFontSize);

                                const newWidth = calculateTextWidth(
                                  text.text,
                                  newFontSize,
                                  text.fontFamily
                                );

                                setTexts((prev) =>
                                  prev.map((item) =>
                                    item.id === text.id
                                      ? {
                                          ...item,
                                          fontSize: newFontSize,
                                          width: Math.max(newWidth, 50),
                                          align: "left",
                                        }
                                      : item
                                  )
                                );
                              }}
                            />
                          </Group>
                        );
                      })}

                      {showDefaultColorPicker && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: `${defaultColorPickerPosition.top}px`,
                            left: `${defaultColorPickerPosition.left}px`,
                            zIndex: 999,
                          }}
                          ref={defaultColorPickerRef}
                        >
                          <ChromePicker
                            color={defaultTextColor}
                            onChange={(color) => setDefaultTextColor(color.hex)}
                            disableAlpha
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}

                {selectedTool === "text" &&
                  selectedTextId &&
                  (() => {
                    const selected = texts.find((t) => t.id === selectedTextId);
                    if (!selected) return null;

                    return (
                      <Box mt={2}>
                        <Typography
                          variant="body2"
                          mb={1}
                          sx={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          Cập nhật màu và nội dung chữ:
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                          {/* Màu chữ */}
                          <Box>
                            <Typography variant="body2" sx={{ fontSize: 14, mb: 1 }}>
                              Màu chữ
                            </Typography>
                            <ChromePicker
                              color={selected.fill || "#000000"}
                              onChange={(color) => {
                                const newColor = color.hex;
                                setTexts((prev) =>
                                  prev.map((t) =>
                                    t.id === selectedTextId ? { ...t, fill: newColor } : t
                                  )
                                );
                              }}
                              disableAlpha
                              width={120}
                            />
                          </Box>

                          {/* Text content */}
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={{ fontSize: 14, mb: 1 }}>
                              Nội dung
                            </Typography>
                            <TextField
                              value={selected.text}
                              onChange={(e) => {
                                const newText = e.target.value;
                                setTextInput(newText);

                                const selectedText = texts.find((t) => t.id === selectedTextId);
                                if (!selectedText) return;

                                // Tính toán width mới dựa trên dòng dài nhất
                                const newWidth = calculateTextWidth(
                                  newText,
                                  selectedText.fontSize,
                                  selectedText.fontFamily
                                );

                                setTexts((prev) =>
                                  prev.map((t) =>
                                    t.id === selectedTextId
                                      ? {
                                          ...t,
                                          text: newText,
                                          width: Math.max(newWidth, 50), // Đảm bảo width không quá nhỏ
                                          align: "left", // Căn trái
                                        }
                                      : t
                                  )
                                );
                              }}
                              multiline
                              minRows={6}
                              maxRows={6}
                              placeholder="Nhập nội dung"
                              fullWidth
                              sx={{
                                background: "#fff",
                                borderRadius: "0.5rem !important",
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    );
                  })()}

                {selectedTool === "upload" && (
                  <Box ref={colorPickerRef} sx={{ position: "relative", mt: 2 }}>
                    <Box>
                      <DragDropZoneMulti
                        label="Tải ảnh lên"
                        files={dropzoneFiles}
                        setFiles={(newFiles) => setDropzoneFiles(newFiles)}
                        uploadInputRef={uploadInputRef}
                        uploadedImages={uploadedImages}
                        selectedImageId={selectedImageId}
                        setSelectedImageId={setSelectedImageId}
                        setUploadedImages={setUploadedImages}
                        disabled={isMannequinSelected}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              {/* body 3 */}
              <Box
                sx={{
                  order: { xs: 3, md: 2 },
                  width: "100%", // ✅ luôn 100% trên mọi màn
                  maxWidth: { xs: "100%", md: "100%" }, // ✅ giới hạn ở desktop
                  flex: 1,
                  backgroundColor: "#f0f0f0",
                  p: { xs: 1, md: 2 }, // ✅ giảm padding mobile
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderTopRightRadius: { xs: 0, md: 12 },
                  borderBottomRightRadius: { xs: 0, md: 12 },
                  borderBottomLeftRadius: { xs: 12, md: 0 }, // ✅ bo ở mobile
                  overflow: "hidden", // ✅ tránh scroll ngang
                  minHeight: { xs: "60vh", sm: 500, md: "100%" },
                }}
              >
                <Box
                  sx={{
                    position: "relative", // ✅ để định vị các nút overlay
                    width: "100%", // ✅ tránh vượt khung
                    maxWidth: { xs: "100%", md: 800 }, // ✅ giới hạn desktop
                    overflowX: "hidden", // ✅ tránh scroll ngang
                    flex: 1,
                    backgroundColor: "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 2,
                  }}
                >
                  <Box
                    ref={canvasContainerRef}
                    onContextMenu={(e) => e.preventDefault()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      if (isMannequinSelected) return;
                      increaseActionCount();
                      e.preventDefault();
                      const stickerSrc = e.dataTransfer.getData("application/sticker-src");
                      if (stickerSrc && stickerSrc !== "undefined") {
                        const img = new window.Image();
                        img.src = stickerSrc;
                        img.onload = () => {
                          pushUndoSnapshot();
                          const id = `sticker-${Date.now()}-${Math.random()}`;
                          const maxW = canvasWidth;
                          const maxH = canvasHeight;
                          const scale = Math.min(maxW / img.width, maxH / img.height, 1);

                          const width = img.width * scale;
                          const height = img.height * scale;
                          const x = canvasWidth / 2 - width / 2;
                          const y = canvasHeight / 2 - height / 2;
                          setStickers((prev) => [
                            ...prev,
                            {
                              id,
                              image: img,
                              x,
                              y,
                              width,
                              height,
                              flipX: false,
                              layerKey: `${currentAttachType}-${selectedLayerId}`,
                              attachType: currentAttachType,
                            },
                          ]);
                        };
                      }
                      // else if (e.dataTransfer?.files?.length > 0) {
                      //   const file = e.dataTransfer.files[0];
                      //   const reader = new FileReader();
                      //   reader.onload = () => {
                      //     const imageObj = new window.Image();
                      //     imageObj.src = reader.result;
                      //     imageObj.onload = () => {
                      //       pushUndoSnapshot();
                      //       const id = `upload-${Date.now()}`;
                      //       setUploadedImages((prev) => [
                      //         ...prev,
                      //         {
                      //           id,
                      //           image: imageObj,
                      //           x: pointer.x - imageObj.width / 2,
                      //           y: pointer.y - imageObj.height / 2,
                      //           width: imageObj.width,
                      //           height: imageObj.height,
                      //           flipX: false,
                      //           layerKey: `${currentAttachType}-${selectedLayerId}`,
                      //         },
                      //       ]);
                      //     };
                      //   };
                      //   reader.readAsDataURL(file);
                      // }
                    }}
                    sx={{
                      width: canvasWidth,
                      height: canvasHeight,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      padding: 0,
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          handleUndo();
                        }}
                        // disabled={!hasUndoForCurrentAttachType}
                      >
                        <Tooltip title="Hoàn tác">
                          <Undo sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          handleRedo();
                        }}
                        // disabled={!hasRedoForCurrentAttachType}
                      >
                        <Tooltip title="Làm lại">
                          <Redo sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={(e) => {
                          increaseActionCount();
                          handleZoomPopover(e);
                        }}
                      >
                        <Tooltip title="Phóng to">
                          <ZoomIn sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <Popover
                        open={Boolean(zoomAnchorEl)}
                        anchorEl={zoomAnchorEl}
                        onClose={() => setZoomAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        PaperProps={{
                          sx: {
                            minWidth: 300,
                            maxWidth: 350,
                            p: 2,
                            border: "1px solid #ccc",
                            borderRadius: 2,
                            boxShadow: 6,
                            backgroundColor: "#fff",
                            overflow: "hidden !important", // ❗ tránh scroll
                          },
                        }}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            gutterBottom
                            sx={{ fontWeight: 600, textAlign: "center", mb: 1 }}
                          >
                            Zoom thiết kế
                          </Typography>

                          <Box sx={{ px: 1 }}>
                            <Slider
                              min={1}
                              max={3}
                              step={0.01}
                              value={tempZoom}
                              onChange={(e, newVal) => {
                                setTempZoom(newVal);
                                handleZoom(newVal); // ✅ dùng hàm zoom từ tâm
                              }}
                              valueLabelDisplay="auto"
                              valueLabelFormat={(value) => `${(value * 100).toFixed(0)}%`}
                              sx={{
                                width: "100%",
                                color: "white",
                                "& .MuiSlider-thumb": {
                                  boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                                },
                              }}
                            />
                          </Box>

                          <Typography
                            variant="body2"
                            textAlign="center"
                            mt={1}
                            color="text.secondary"
                          >
                            {(tempZoom * 100).toFixed(0)}% kích thước gốc
                          </Typography>
                        </Box>
                      </Popover>

                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          handleZoomOut();
                        }}
                      >
                        <Tooltip title="Thu nhỏ">
                          <ZoomOut sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          resetCanvas();
                        }}
                      >
                        <Tooltip title="Tải lại">
                          <Refresh sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                    </Box>

                    <Stage
                      ref={stageRef}
                      width={canvasWidth}
                      height={canvasHeight}
                      style={{
                        width: "100%",
                        maxWidth: "100%", // ✅ ngăn vượt ra
                        display: "block",
                        backgroundColor: "white",
                      }}
                      scale={{ x: zoom, y: zoom }}
                      onMouseDown={handleStageMouseDown}
                      onTouchStart={handleStageMouseDown}
                    >
                      <Layer>
                        <Group
                          x={(canvasWidth - scaledImageSize.width) / 2}
                          y={(canvasHeight - scaledImageSize.height) / 2}
                          clipFunc={(ctx) => {
                            ctx.rect(0, 0, scaledImageSize.width, scaledImageSize.height);
                          }}
                        >
                          {(() => {
                            const displayItems = [];

                            // 1. Ảnh nền mờ
                            if (highlightImage) {
                              displayItems.push({
                                order: 0,
                                element: (
                                  <KonvaImage
                                    image={highlightImage}
                                    x={0}
                                    y={0}
                                    width={scaledImageSize.width}
                                    height={scaledImageSize.height}
                                    opacity={0.5}
                                    listening={false}
                                    globalCompositeOperation="multiply"
                                  />
                                ),
                              });
                            }

                            // 2. Ảnh đổi màu
                            if (highlightImage) {
                              displayItems.push({
                                order: 1,
                                element: (
                                  <KonvaImage
                                    image={highlightImage}
                                    ref={highlightImageRef}
                                    x={0}
                                    y={0}
                                    width={scaledImageSize.width}
                                    height={scaledImageSize.height}
                                    listening={false}
                                    filters={[Konva.Filters.RGBA]}
                                    alpha={1}
                                    globalCompositeOperation="multiply"
                                  />
                                ),
                              });
                            }

                            // 3. Overlay layers
                            overlayLayers.forEach((layer, idx) => {
                              displayItems.push({
                                order: layer.displayOrder ?? idx + 2,
                                element: (
                                  <KonvaImage
                                    key={layer.id}
                                    image={layer.image}
                                    ref={(node) => {
                                      overlayKonvaRefs.current[idx] = node;
                                    }}
                                    x={0}
                                    y={0}
                                    width={scaledImageSize.width}
                                    height={scaledImageSize.height}
                                  />
                                ),
                              });
                            });

                            // 4. Ảnh mặt trước (nếu đang ở mặt manocanh)
                            if (overlayImageFront && currentAttachType === 4) {
                              const frontWidth = overlayFrontSize.width * frontScale;
                              const frontHeight = overlayFrontSize.height * frontScale;
                              const offsetX = (scaledImageSize.width - frontWidth) / 2;
                              const offsetY = (scaledImageSize.height - frontHeight) / 2;

                              displayItems.push({
                                order: overlayFrontOrder,
                                element: (
                                  <KonvaImage
                                    image={overlayImageFront}
                                    x={offsetX}
                                    y={offsetY}
                                    width={frontWidth}
                                    height={frontHeight}
                                  />
                                ),
                              });
                            }

                            // 5. Texts
                            texts.forEach((text) => {
                              if (!textRefs.current[text.id]) {
                                textRefs.current[text.id] = React.createRef();
                              }

                              const arcRadius = text.arcRadius || 150;
                              const arcDirection = text.arcDirection || "down"; // "up" hoặc "down"

                              // Tính kích thước và tâm của văn bản cong
                              const {
                                width: groupWidth,
                                height: groupHeight,
                                centerY,
                              } = calculateCurvedTextBounds(
                                text.text,
                                text.fontSize || 20,
                                text.fontFamily || "Arial",
                                arcRadius,
                                text.lineSpacing || 40
                              );

                              // Tạo pathData cho TextPath
                              const cx = groupWidth / 2; // Tâm của TextPath nằm ở giữa groupWidth
                              const cy = centerY; // Tâm Y dựa trên centerY của văn bản cong
                              const x1 = cx - arcRadius;
                              const x2 = cx + arcRadius;
                              const y = cy;
                              const sweepFlag = arcDirection === "up" ? 0 : 1;
                              const pathData = `M ${x1},${y} A ${arcRadius},${arcRadius} 0 0 ${sweepFlag} ${x2},${y}`;

                              displayItems.push({
                                order: 10,
                                element: text.isCurved ? (
                                  <TextPath
                                    id={text.id}
                                    ref={(node) => {
                                      if (node) {
                                        textRefs.current[text.id] = node;
                                      } else {
                                        delete textRefs.current[text.id]; // Tốt nếu node bị unmount
                                      }
                                    }}
                                    data={pathData}
                                    x={text.x}
                                    y={text.y}
                                    offsetX={groupWidth / 2}
                                    offsetY={centerY}
                                    width={groupWidth}
                                    // Bỏ offsetX, offsetY vì đã điều chỉnh x, y để căn tâm
                                    text={text.text}
                                    fontSize={text.fontSize || 20}
                                    fill={text.fill}
                                    fontFamily={text.fontFamily || "Arial"}
                                    fontStyle={text.fontStyle || "normal"}
                                    textDecoration={text.textDecoration || "none"}
                                    align={text.align || "center"}
                                    letterSpacing={text.letterSpacing || 0}
                                    rotation={text.rotation || 0}
                                    draggable
                                    onDragEnd={(e) => {
                                      pushUndoSnapshot();
                                      const node = e.target;
                                      const dragX = node.x();
                                      const dragY = node.y();

                                      setTexts((prev) =>
                                        prev.map((item) =>
                                          item.id === text.id
                                            ? {
                                                ...item,
                                                x: dragX,
                                                y: dragY,
                                                width: groupWidth,
                                                height: groupHeight,
                                              }
                                            : item
                                        )
                                      );
                                      node.getLayer()?.batchDraw();
                                      saveCurrentCanvasState();
                                    }}
                                    onTransformEnd={(e) => {
                                      pushUndoSnapshot();
                                      const node = e.target;
                                      // const scaleX = node.scaleX();
                                      const scaleY = node.scaleY();
                                      const newFontSize = (text.fontSize || 20) * scaleY;
                                      const newRadius = arcRadius * scaleY;
                                      const rotation = node.rotation();

                                      node.scaleX(1);
                                      node.scaleY(1);

                                      const { adjustedFontSize, adjustedRadius } =
                                        adjustCurvedTextToFit(
                                          {
                                            text: text.text,
                                            fontSize: newFontSize,
                                            fontFamily: text.fontFamily || "Arial",
                                            arcRadius: newRadius,
                                            lineSpacing: text.lineSpacing || 40,
                                          },
                                          canvasWidth,
                                          canvasHeight
                                        );

                                      const { width: newGroupWidth, height: newGroupHeight } =
                                        calculateCurvedTextBounds(
                                          text.text,
                                          adjustedFontSize,
                                          text.fontFamily || "Arial",
                                          adjustedRadius,
                                          text.lineSpacing || 40
                                        );

                                      const currentX = node.x();
                                      const currentY = node.y();

                                      setTexts((prev) =>
                                        prev.map((t) =>
                                          t.id === text.id
                                            ? {
                                                ...t,
                                                fontSize: adjustedFontSize,
                                                arcRadius: adjustedRadius,
                                                x: currentX, // ✅ Không tính lệch nữa
                                                y: currentY,
                                                width: newGroupWidth,
                                                height: newGroupHeight,
                                                rotation,
                                              }
                                            : t
                                        )
                                      );

                                      node.getLayer()?.batchDraw();
                                      saveCurrentCanvasState();
                                    }}
                                  />
                                ) : (
                                  <Group key={text.id} onClick={() => setSelectedTextId(text.id)}>
                                    <Text
                                      id={text.id}
                                      ref={(node) => {
                                        if (node) {
                                          textRefs.current[text.id] = node;
                                        } else {
                                          delete textRefs.current[text.id]; // Tốt nếu node bị unmount
                                        }
                                      }}
                                      text={text.text}
                                      x={text.x || 0}
                                      y={text.y || 0}
                                      width={text.width || 300}
                                      align={text.align || "center"}
                                      fontSize={text.fontSize || 20}
                                      wrap="word"
                                      fill={text.fill}
                                      rotation={text.rotation || 0}
                                      fontFamily={text.fontFamily || "Arial"}
                                      fontStyle={text.fontStyle || "normal"}
                                      textDecoration={text.textDecoration || "none"}
                                      draggable
                                      onDragEnd={(e) => {
                                        pushUndoSnapshot();
                                        const node = e.target;
                                        const dragX = node.x();
                                        const dragY = node.y();

                                        setTexts((prev) =>
                                          prev.map((item) =>
                                            item.id === text.id
                                              ? { ...item, x: dragX, y: dragY }
                                              : item
                                          )
                                        );
                                        saveCurrentCanvasState();
                                        node.getLayer()?.batchDraw();
                                      }}
                                      onTransformEnd={(e) => {
                                        pushUndoSnapshot();
                                        const node = e.target;
                                        const rotation = node.rotation();
                                        const scaleY = node.scaleY();
                                        const newFontSize = (text.fontSize || 20) * scaleY;
                                        const dragX = node.x();
                                        const dragY = node.y();

                                        node.scaleX(1);
                                        node.scaleY(1);

                                        const newWidth = calculateTextWidth(
                                          text.text,
                                          newFontSize,
                                          text.fontFamily || "Arial"
                                        );

                                        setTexts((prev) =>
                                          prev.map((item) =>
                                            item.id === text.id
                                              ? {
                                                  ...item,
                                                  fontSize: newFontSize,
                                                  width: Math.max(newWidth, 50),
                                                  height: newFontSize,
                                                  align: item.align || "left",
                                                  rotation,
                                                  x: dragX,
                                                  y: dragY,
                                                }
                                              : item
                                          )
                                        );
                                        saveCurrentCanvasState();
                                        node.getLayer()?.batchDraw();
                                      }}
                                    />
                                  </Group>
                                ),
                              });
                            });

                            // 6. Stickers
                            stickers.forEach((img) => {
                              displayItems.push({
                                order: 11,
                                element: (
                                  <KonvaImage
                                    key={img.id}
                                    id={img.id}
                                    ref={(node) => {
                                      if (node) stickerRefs.current[img.id] = node;
                                    }}
                                    image={img.image}
                                    x={img.x}
                                    y={img.y}
                                    width={img.width}
                                    height={img.height}
                                    draggable
                                    dragBoundFunc={createDragBoundFunc(img.width, img.height)}
                                    rotation={img.rotation || 0}
                                    onClick={() => setSelectedStickerId(img.id)}
                                    onDragEnd={(e) => {
                                      pushUndoSnapshot();
                                      const { x, y } = e.target.position();
                                      setStickers((prev) =>
                                        prev.map((item) =>
                                          item.id === img.id ? { ...item, x, y } : item
                                        )
                                      );
                                      saveCurrentCanvasState();
                                    }}
                                    onTransformEnd={(e) => {
                                      const node = e.target;
                                      const scaleX = node.scaleX() * (img.flipX ? -1 : 1); // Adjust for flip
                                      const scaleY = node.scaleY();
                                      const rotation = node.rotation();

                                      // Reset transformer scale
                                      node.scaleX(img.flipX ? -1 : 1); // Preserve flip
                                      node.scaleY(1);

                                      // Calculate unscaled dimensions and position
                                      const newWidth = node.width() * Math.abs(scaleX);
                                      const newHeight = node.height() * scaleY;
                                      const newX = node.x();
                                      const newY = node.y();

                                      // Update state with unscaled values
                                      setStickers((prev) =>
                                        prev.map((item) =>
                                          item.id === img.id
                                            ? {
                                                ...item,
                                                x: newX,
                                                y: newY,
                                                width: newWidth,
                                                height: newHeight,
                                                rotation,
                                              }
                                            : item
                                        )
                                      );

                                      // Update node with zoom-scaled dimensions
                                      node.width(newWidth);
                                      node.height(newHeight);
                                      node.x(newX);
                                      node.y(newY);
                                      node.rotation(rotation);
                                      node.getLayer().batchDraw();
                                      saveCurrentCanvasState();
                                    }}
                                  />
                                ),
                              });
                            });

                            // 7. Uploaded Images
                            uploadedImages.forEach((img) => {
                              displayItems.push({
                                order: 12,
                                element: (
                                  <KonvaImage
                                    key={img.id}
                                    id={img.id}
                                    ref={(node) => {
                                      if (node) uploadImageRefs.current[img.id] = node;
                                    }}
                                    image={img.image}
                                    x={img.x}
                                    y={img.y}
                                    width={img.width}
                                    height={img.height}
                                    draggable
                                    dragBoundFunc={createDragBoundFunc(img.width, img.height)}
                                    rotation={img.rotation || 0}
                                    onClick={() => {
                                      setImageToCrop(img.image?.src);
                                    }}
                                    onDragEnd={(e) => {
                                      pushUndoSnapshot();
                                      const { x, y } = e.target.position();
                                      setUploadedImages((prev) =>
                                        prev.map((item) =>
                                          item.id === img.id ? { ...item, x, y } : item
                                        )
                                      );
                                      saveCurrentCanvasState();
                                    }}
                                    onTransformEnd={(e) => {
                                      const node = e.target;
                                      const scaleX = node.scaleX() * (img.flipX ? -1 : 1); // Adjust for flip
                                      const scaleY = node.scaleY();
                                      const rotation = node.rotation();

                                      // Reset transformer scale
                                      node.scaleX(img.flipX ? -1 : 1); // Preserve flip
                                      node.scaleY(1);

                                      // Calculate unscaled dimensions and position
                                      const newWidth = node.width() * Math.abs(scaleX);
                                      const newHeight = node.height() * scaleY;
                                      const newX = node.x();
                                      const newY = node.y();

                                      // Update state with unscaled values
                                      setUploadedImages((prev) =>
                                        prev.map((item) =>
                                          item.id === img.id
                                            ? {
                                                ...item,
                                                x: newX,
                                                y: newY,
                                                width: newWidth,
                                                height: newHeight,
                                                rotation,
                                              }
                                            : item
                                        )
                                      );

                                      // Update node with zoom-scaled dimensions
                                      node.width(newWidth);
                                      node.height(newHeight);
                                      node.x(newX);
                                      node.y(newY);
                                      node.rotation(rotation);
                                      node.getLayer().batchDraw();
                                      saveCurrentCanvasState();
                                    }}
                                  />
                                ),
                              });
                            });
                            return displayItems
                              .sort((a, b) => a.order - b.order)
                              .map((item, idx) => (
                                <React.Fragment key={idx}>{item.element}</React.Fragment>
                              ));
                          })()}

                          {showWatermark && watermarkImage && (
                            <KonvaImage
                              image={watermarkImage}
                              x={scaledWatermarkSize.x}
                              y={scaledWatermarkSize.y}
                              width={scaledWatermarkSize.width}
                              height={scaledWatermarkSize.height}
                              opacity={0.2}
                              listening={false}
                            />
                          )}

                          {showWatermark && (
                            <KonvaImage
                              image={SampleLogo}
                              // x={(scaledImageSize.width - logoWidth) / 2}
                              x={0}
                              y={Math.max(
                                (canvasHeight - scaledImageSize.height) / 2 - logoHeight,
                                4
                              )}
                              width={logoWidth}
                              height={logoHeight}
                              listening={false}
                            />
                          )}

                          <Transformer
                            ref={transformerRef}
                            rotateEnabled={true}
                            enabledAnchors={[
                              "top-left",
                              "top-right",
                              "bottom-left",
                              "bottom-right",
                            ]}
                            anchorSize={isMobile ? 16 : 10} // to rõ anchor
                            padding={isMobile ? 10 : 4} // thêm khoảng cách giữa box và anchor
                            rotateAnchorOffset={isMobile ? 60 : 40} // đẩy nút xoay ra xa hơn
                            hitStrokeWidth={60} // dễ click trên mobile
                          />
                        </Group>
                      </Layer>
                    </Stage>
                    {selectedTextId &&
                      (() => {
                        const selected = texts.find((t) => t.id === selectedTextId);
                        const selectedText = selected;
                        const konvaNode = stageRef.current?.findOne(`#${selectedTextId}`);
                        const containerBox = canvasContainerRef.current?.getBoundingClientRect();
                        if (!konvaNode || !containerBox) return null;

                        const rect = konvaNode.getClientRect({ relativeTo: stageRef.current });
                        const TOOLBAR_HEIGHT = 40;
                        const topOffset = { xs: 5, sm: 25 };
                        const leftOffset = { xs: -60, sm: 0 };

                        const rotation = selectedText?.rotation || 0;
                        const facingDown = isTextFacingDown(rotation);
                        let top;
                        let left;
                        if (window.innerWidth >= 600) {
                          top = facingDown
                            ? rect.y - topOffset.sm - TOOLBAR_HEIGHT
                            : rect.y + rect.height + topOffset.sm;
                          left = rect.x + leftOffset.sm;
                        } else {
                          top = facingDown
                            ? rect.y - topOffset.xs - TOOLBAR_HEIGHT
                            : rect.y + rect.height + topOffset.xs;
                          left = rect.x + leftOffset.xs;
                        }

                        return (
                          <Box
                            sx={{
                              position: "absolute",
                              top: { xs: `${top}px`, sm: `${top}px` }, // Responsive top
                              left: { xs: `${left}px`, sm: `${left}px` }, // Responsive left
                              zIndex: 1000,
                              background: "#ddd",
                              borderRadius: 1,
                              display: "flex",
                              alignItems: "center",
                              px: { xs: 0.5, sm: 1 },
                              py: { xs: 0.25, sm: 0.5 },
                              gap: { xs: 0.5, sm: 1 },
                              flexWrap: { xs: "nowrap", sm: "nowrap" },
                              overflowX: { xs: "auto", sm: "visible" },
                              maxWidth: { xs: "90vw", sm: "auto" },
                              boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {/* Font dropdown */}
                            <TextField
                              select
                              value={selected?.fontFamily || "Arial"}
                              onChange={async (e) => {
                                const newFont = e.target.value;

                                const fontItem = fontList.find(
                                  (f) => f.fontFamily.split(",")[0].trim() === newFont
                                );

                                if (fontItem?.attachment?.encryptedId) {
                                  try {
                                    const fontUrl = await getImageUrl(
                                      `/api/public/attachments/downloadFile/${fontItem.attachment.encryptedId}`
                                    );
                                    await loadFontFromUrl(newFont, fontUrl);
                                  } catch (err) {
                                    console.warn("Không thể tải font:", err);
                                  }
                                } else {
                                  console.warn("Font không có file đính kèm:", newFont);
                                }

                                setTexts((prev) =>
                                  prev.map((t) =>
                                    t.id === selectedTextId ? { ...t, fontFamily: newFont } : t
                                  )
                                );
                              }}
                              SelectProps={{ native: true }}
                              size="small"
                              sx={{
                                minWidth: { xs: 80, sm: 100 }, // Giảm chiều rộng trên mobile
                                background: "white",
                                borderRadius: "0.5rem !important",
                                "& .MuiSelect-select": {
                                  py: { xs: 0.5, sm: 1 }, // Giảm padding select trên mobile
                                },
                              }}
                            >
                              {fontList
                                .filter((f) => f.fontFamily) // chỉ render font hợp lệ
                                .map((f, i) => {
                                  const fontName = f.fontFamily.split(",")[0].trim();
                                  return (
                                    <option key={i} value={fontName}>
                                      {fontName}
                                    </option>
                                  );
                                })}
                            </TextField>

                            {/* Căn lề */}
                            <AlignDropdown
                              currentAlign={
                                texts.find((t) => t.id === selectedTextId)?.align || "center"
                              }
                              onChange={(e) => {
                                increaseActionCount();
                                handleChangeAlign(e);
                              }}
                            />

                            {/* Chữ vòng cung */}
                            <Tooltip title="Độ cong">
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  if (!selectedTextId) return;
                                  increaseActionCount();
                                  setCurveAnchorEl(e.currentTarget); // ✅ chỉ mở Popover
                                  // ✅ chỉ set arcRadius mặc định nếu chưa có (KHÔNG bật cong)
                                  setTexts((prev) =>
                                    prev.map((t) =>
                                      t.id === selectedTextId
                                        ? {
                                            ...t,
                                            arcRadius: t.arcRadius ?? 50,
                                            arcDirection: t.arcDirection ?? "down",
                                          }
                                        : t
                                    )
                                  );
                                }}
                                sx={{
                                  color: selectedText?.isCurved ? "#1976d2" : "inherit",
                                }}
                              >
                                <WavesIcon sx={{ fontSize: 18 }} />
                              </IconButton>
                            </Tooltip>

                            <Popover
                              open={Boolean(curveAnchorEl)}
                              anchorEl={curveAnchorEl}
                              onClose={() => setCurveAnchorEl(null)}
                              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                              transformOrigin={{ vertical: "top", horizontal: "left" }}
                              PaperProps={{
                                sx: {
                                  p: 1.5,
                                  minWidth: 160,
                                  backgroundColor: "#fff",
                                  borderRadius: 1.5,
                                  boxShadow: 3,
                                },
                              }}
                            >
                              <Stack spacing={1}>
                                {/* Bật chữ cong + Hướng */}
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Switch
                                    checked={selectedText?.isCurved || false}
                                    onChange={(e) => {
                                      pushUndoSnapshot();
                                      const isCurved = e.target.checked;

                                      setTexts((prev) =>
                                        prev.map((t) => {
                                          if (t.id !== selectedTextId) return t;

                                          const arcRadius = t.arcRadius ?? 150;
                                          const lineSpacing = t.lineSpacing ?? 40;
                                          const fontSize = t.fontSize || 20;
                                          const fontFamily = t.fontFamily || "Arial";

                                          // Tính lại text ngang
                                          const normalWidth = calculateTextWidth(
                                            t.text,
                                            fontSize,
                                            fontFamily
                                          );
                                          const normalHeight = fontSize;

                                          // Tính lại text cong
                                          const curvedBounds = calculateCurvedTextBounds(
                                            t.text,
                                            fontSize,
                                            fontFamily,
                                            arcRadius,
                                            lineSpacing
                                          );
                                          const {
                                            width: curvedWidth,
                                            height: curvedHeight,
                                            // centerY,
                                          } = curvedBounds;

                                          // Luôn xác định tâm hiện tại
                                          const currentCenterX = isCurved
                                            ? t.x // đang ở chế độ cong → x là tâm
                                            : t.x + normalWidth / 2;

                                          const currentCenterY = isCurved
                                            ? t.y // đang cong → y là tâm
                                            : t.y + normalHeight / 2;

                                          // Gán vị trí mới:
                                          let newX;
                                          let newY;
                                          if (isCurved) {
                                            // Sang cong → dùng tâm hiện tại
                                            newX = currentCenterX;
                                            newY = currentCenterY;
                                          } else {
                                            // Sang ngang → trừ về góc trái
                                            newX = currentCenterX - normalWidth / 2;
                                            newY = currentCenterY - normalHeight / 2;
                                          }

                                          return {
                                            ...t,
                                            isCurved,
                                            arcRadius,
                                            arcDirection: t.arcDirection ?? "down",
                                            width: isCurved ? curvedWidth : normalWidth,
                                            height: isCurved ? curvedHeight : normalHeight,
                                            x: newX,
                                            y: newY,
                                          };
                                        })
                                      );
                                    }}
                                  />
                                  <ToggleButtonGroup
                                    value={selectedText?.arcDirection || "down"}
                                    exclusive
                                    onChange={(e, newVal) => {
                                      if (!newVal) return;
                                      setTexts((prev) =>
                                        prev.map((t) =>
                                          t.id === selectedTextId
                                            ? { ...t, arcDirection: newVal }
                                            : t
                                        )
                                      );
                                    }}
                                    size="small"
                                    sx={{ height: 32 }}
                                  >
                                    <Tooltip title="Cong lên">
                                      <ToggleButton value="down">
                                        <KeyboardArrowUpIcon fontSize="small" />
                                      </ToggleButton>
                                    </Tooltip>

                                    <Tooltip title="Cong xuống">
                                      <ToggleButton value="up">
                                        <KeyboardArrowDownIcon fontSize="small" />
                                      </ToggleButton>
                                    </Tooltip>
                                  </ToggleButtonGroup>
                                </Stack>

                                {/* Độ cong */}
                                <TextField
                                  type="number"
                                  size="small"
                                  inputProps={{ min: 0 }}
                                  value={selectedText?.arcRadius || 150}
                                  onChange={(e) => {
                                    const val = parseInt(e.target.value, 10);
                                    if (Number.isNaN(val)) return;
                                    setTexts((prev) =>
                                      prev.map((t) =>
                                        t.id === selectedTextId
                                          ? { ...t, arcRadius: Math.max(0, val) }
                                          : t
                                      )
                                    );
                                  }}
                                  sx={{ width: 80 }}
                                />
                              </Stack>
                            </Popover>

                            {/* In đậm */}
                            <Tooltip title="In đậm">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  // Toggle Bold
                                  setTexts((prev) =>
                                    prev.map((t) => {
                                      if (t.id !== selectedTextId) return t;

                                      let fontStyle = t.fontStyle || "normal";
                                      if (fontStyle.includes("italic")) {
                                        fontStyle = fontStyle.includes("bold")
                                          ? "italic"
                                          : "bold italic";
                                      } else {
                                        fontStyle = fontStyle.includes("bold") ? "normal" : "bold";
                                      }

                                      return { ...t, fontStyle };
                                    })
                                  );
                                }}
                                sx={{ p: { xs: 0.5, sm: 1 } }}
                              >
                                <Typography fontWeight="bold" sx={{ fontSize: { xs: 12, sm: 14 } }}>
                                  B
                                </Typography>
                              </IconButton>
                            </Tooltip>

                            {/* In nghiêng */}
                            <Tooltip title="In nghiêng">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  // Toggle Italic
                                  setTexts((prev) =>
                                    prev.map((t) => {
                                      if (t.id !== selectedTextId) return t;

                                      let fontStyle = t.fontStyle || "normal";
                                      if (fontStyle.includes("bold")) {
                                        fontStyle = fontStyle.includes("italic")
                                          ? "bold"
                                          : "bold italic";
                                      } else {
                                        fontStyle = fontStyle.includes("italic")
                                          ? "normal"
                                          : "italic";
                                      }

                                      return { ...t, fontStyle };
                                    })
                                  );
                                }}
                                sx={{ p: { xs: 0.5, sm: 1 } }}
                              >
                                <Typography
                                  fontStyle="italic"
                                  sx={{ fontSize: { xs: 12, sm: 14 } }}
                                >
                                  I
                                </Typography>
                              </IconButton>
                            </Tooltip>

                            {/* Gạch chân */}
                            <Tooltip title="Gạch chân">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setTexts((prev) =>
                                    prev.map((t) =>
                                      t.id === selectedTextId
                                        ? {
                                            ...t,
                                            textDecoration:
                                              t.textDecoration === "underline"
                                                ? "none"
                                                : "underline",
                                          }
                                        : t
                                    )
                                  );
                                }}
                                sx={{ p: { xs: 0.5, sm: 1 } }}
                              >
                                <Typography
                                  sx={{ textDecoration: "underline", fontSize: { xs: 12, sm: 14 } }}
                                >
                                  U
                                </Typography>
                              </IconButton>
                            </Tooltip>
                          </Box>
                        );
                      })()}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          handlePreviewDesign();
                        }}
                      >
                        <Tooltip title="Xem trước">
                          <Visibility sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      {/* <IconButton size="small" onClick={() => console.log("Thông tin")}>
                        <InfoOutlined sx={{ fontSize: 24, color: "#007aff" }} />
                      </IconButton> */}
                      {/* ✅ Thêm tooltip icon cảnh báo */}
                      <Tooltip
                        title={
                          <Box sx={{ p: 1 }}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                mb: 1,
                                color: "white",
                              }}
                            >
                              ⚠️ Lưu ý quan trọng
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: 13,
                                lineHeight: 1.4,
                                color: "white",
                                textAlign: "left",
                              }}
                            >
                              • Thiết kế chỉ mang tính chất tham khảo
                              <br />• Nếu bạn cần mẫu thiết kế chi tiết, vui lòng liên hệ Đồng phục
                              Zumi để được hỗ trợ và tư vấn đặt áo
                            </Typography>
                          </Box>
                        }
                        arrow
                        placement="bottom-start"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "rgba(0, 0, 0, 0.9)",
                              maxWidth: 300,
                              fontSize: 13,
                              borderRadius: 2,
                              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "rgba(0, 0, 0, 0.9)",
                            },
                          },
                        }}
                      >
                        <IconButton
                          size="small"
                          sx={{
                            color: "#007aff",
                            // "&:hover": {
                            //   backgroundColor: "rgba(255, 152, 0, 0.1)",
                            // },
                          }}
                        >
                          <InfoOutlined sx={{ fontSize: 23 }} />
                        </IconButton>
                      </Tooltip>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          moveSelected(0, -10);
                        }}
                      >
                        <Tooltip title="Di chuyển lên">
                          <ArrowUpward sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          moveSelected(10, 0);
                        }}
                      >
                        <Tooltip title="Di chuyển qua phải">
                          <ArrowForward sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          moveSelected(0, 10);
                        }}
                      >
                        <Tooltip title="Di chuyển xuống">
                          <ArrowDownward sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          moveSelected(-10, 0);
                        }}
                      >
                        <Tooltip title="Di chuyển qua trái">
                          <ArrowBack sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          duplicateSelected();
                        }}
                      >
                        <Tooltip title="Sao chép">
                          <FileCopy sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          increaseActionCount();
                          deleteSelected();
                        }}
                      >
                        <Tooltip title="Xóa">
                          <DeleteOutline sx={{ fontSize: 24, color: "#007aff" }} />
                        </Tooltip>
                      </IconButton>
                    </Box>
                    {/* ✅ Sidebar thumbnail ở góc dưới bên trái */}
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: { xs: 60, sm: 16, md: 16 },
                        left: { xs: 4, sm: 12, md: 16 },
                        display: "flex",
                        flexDirection: "column", // ✅ luôn dọc
                        gap: 1,
                        maxHeight: { xs: 190, sm: 250 },
                        overflowY: "auto",
                        overflowX: "hidden",
                        borderRadius: 1,
                        backgroundColor: "#ffffffdd", // nhẹ, không che nội dung
                        padding: 0.5,
                        zIndex: 10,
                      }}
                    >
                      {[1, 2, 4].map((type) => {
                        const item = selectedProduct?.attachments?.find(
                          (att) => att.attachType === type
                        );
                        const url = item?.encryptedId ? imageMap[item.encryptedId] : null;
                        const isSelected = type === currentAttachType;

                        if (!item || !url) return null;

                        return (
                          <Box
                            key={type}
                            sx={{
                              width: { xs: 40, sm: 60 },
                              height: { xs: 40, sm: 60 },
                              border: isSelected ? "2px solid #1976d2" : "1px solid #ccc",
                              borderRadius: 1,
                              overflow: "hidden",
                              cursor: "pointer",
                              flexShrink: 0,
                              "&:hover": {
                                borderColor: "#1976d2",
                              },
                            }}
                            onClick={() => selectByMatLayer(item)}
                          >
                            <img
                              src={url}
                              alt={item.fileName}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                        );
                      })}
                    </Box>

                    {/* {(() => {
                      if (currentAttachType !== 4) return null;

                      const layersForFace = layerOptions.filter((l) =>
                        [3, 4].includes(l.layerType)
                      );

                      return (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 300,
                            left: -170,
                            background: "#fff",
                            p: 2,
                            borderRadius: 2,
                            boxShadow: 3,
                            minWidth: 260,
                          }}
                        >
                          <Typography fontSize={14} fontWeight="bold" mb={1}>
                            Vị trí chồng ảnh mặt trước
                          </Typography>

                          <TextField
                            type="number"
                            size="small"
                            value={overlayFrontOrder}
                            onChange={(e) =>
                              setOverlayFrontOrder(parseInt(e.target.value, 10) || 0)
                            }
                            inputProps={{ min: 0 }}
                            fullWidth
                            sx={{ mb: 2 }}
                          />

                          <Typography fontSize={13} fontWeight="bold" mb={0.5}>
                            Các vị trí đã dùng:
                          </Typography>

                          <Box
                            sx={{
                              fontSize: 12,
                              maxHeight: 120,
                              overflowY: "auto",
                              background: "#f9f9f9",
                              borderRadius: 1,
                              p: 1,
                              border: "1px solid #ddd",
                            }}
                          >
                            <ul style={{ paddingLeft: 16, margin: 0 }}>
                              {layersForFace.map((layer, idx) => (
                                <li key={layer.id}>
                                  {layer.displayOrder ?? idx + 2}:{" "}
                                  {layer.layerName || `Overlay ${idx + 1}`}
                                </li>
                              ))}
                            </ul>
                          </Box>
                        </Box>
                      );
                    })()} */}

                    {selectedImageId &&
                      (() => {
                        // const selected = images.find((img) => img.id === selectedImageId); // Giả định images là danh sách hình ảnh
                        const konvaNode = stageRef.current?.findOne(`#${selectedImageId}`);
                        const containerBox = canvasContainerRef.current?.getBoundingClientRect();
                        if (!konvaNode || !containerBox) return null;

                        const rect = konvaNode.getClientRect({ relativeTo: stageRef.current });

                        // Định nghĩa offset responsive
                        const topOffset = { xs: 20, sm: 25 }; // Khoảng cách từ hình ảnh nhỏ hơn trên mobile
                        const leftOffset = { xs: -20, sm: 0 }; // Có thể điều chỉnh nếu cần

                        const TOOLBAR_HEIGHT = 40;
                        const rotation = konvaNode.rotation?.() || 0;
                        const facingDown = isTextFacingDown(rotation);
                        let top;
                        let left;
                        if (window.innerWidth >= 600) {
                          top = facingDown
                            ? rect.y - topOffset.sm - TOOLBAR_HEIGHT
                            : rect.y + rect.height + topOffset.sm;
                          left = rect.x + leftOffset.sm;
                        } else {
                          top = facingDown
                            ? rect.y - topOffset.xs - TOOLBAR_HEIGHT
                            : rect.y + rect.height + topOffset.xs;
                          left = rect.x + leftOffset.xs;
                        }

                        return (
                          <Box
                            sx={{
                              position: "absolute",
                              top: { xs: `${top}px`, sm: `${top}px` }, // Responsive top
                              left: { xs: `${left}px`, sm: `${left}px` }, // Responsive left
                              zIndex: 1000,
                              borderRadius: 1,
                              display: "flex",
                              alignItems: "center",
                              px: { xs: 0.5, sm: 1 },
                              py: { xs: 0.25, sm: 0.5 },
                              gap: { xs: 0.5, sm: 1 },
                              flexWrap: { xs: "nowrap", sm: "nowrap" },
                              overflowX: { xs: "auto", sm: "visible" },
                              maxWidth: { xs: "90vw", sm: "auto" },
                              background: "#fff",
                              boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                              whiteSpace: "nowrap",
                              "&::-webkit-scrollbar": { display: "none" },
                              scrollbarWidth: "none",
                            }}
                          >
                            <Tooltip title="Cắt hình">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  p: "4px",
                                  border: "none !important",
                                  "& .MuiTouchRipple-root": { width: 44, height: 44 },
                                }}
                                onClick={() => {
                                  increaseActionCount();
                                  setShowCropModal(true);
                                }}
                              >
                                <Crop sx={{ fontSize: { xs: 14, sm: 18 } }} />
                              </Button>
                            </Tooltip>

                            <Tooltip title="Tách nền">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  p: "4px",
                                  border: "none !important",
                                  "& .MuiTouchRipple-root": { width: 44, height: 44 },
                                }}
                                onClick={async () => {
                                  const sel = uploadedImages.find(
                                    (img) => img.id === selectedImageId
                                  );
                                  if (!sel) return;
                                  increaseActionCount();
                                  // Chuyển ảnh sang Blob
                                  const imageObj = sel.image;

                                  // ✅ Dùng kích thước gốc của ảnh
                                  const canvas = document.createElement("canvas");
                                  canvas.width = imageObj.naturalWidth;
                                  canvas.height = imageObj.naturalHeight;

                                  const ctx = canvas.getContext("2d");
                                  ctx.drawImage(imageObj, 0, 0);

                                  const blobIn = await new Promise((resolve) => {
                                    canvas.toBlob((blob) => {
                                      if (!blob || blob.size === 0) {
                                        console.error("❌ Blob không hợp lệ");
                                        Swal.fire("Lỗi", "Không thể tạo ảnh từ canvas", "error");
                                      } else {
                                        console.log("✅ Blob hợp lệ:", blob.size, blob.type);
                                        // const debugUrl = URL.createObjectURL(blob);
                                        // window.open(debugUrl);
                                      }
                                      resolve(blob);
                                    }, "image/png");
                                  });

                                  // const debugUrl = URL.createObjectURL(blobIn);
                                  // window.open(debugUrl); // Mở tab mới để xem ảnh blob

                                  // Xóa nền
                                  setIsRemovingBg(true); // Bắt đầu loading
                                  let blobOut;
                                  let url;
                                  try {
                                    // Thông báo xử lý lâu (có thể dùng Toast hoặc loading overlay riêng)
                                    Swal.fire({
                                      title: "Đang xử lý ảnh...",
                                      text: "Vui lòng chờ trong giây lát. Việc xóa nền có thể mất vài giây.",
                                      allowOutsideClick: false,
                                      allowEscapeKey: false,
                                      didOpen: () => {
                                        Swal.showLoading();
                                      },
                                    });
                                    blobOut = await callRemoveBgApi(blobIn);
                                    url = URL.createObjectURL(blobOut);
                                  } catch (err) {
                                    blobOut = blobIn;
                                    console.error("Lỗi khi xóa nền:", err);
                                    Swal.fire(
                                      "Lỗi khi xử lý ảnh",
                                      "Không thể xóa nền ảnh. Có thể do ảnh quá lớn hoặc máy chủ đang bận. Vui lòng thử lại sau.",
                                      "error"
                                    );
                                  } finally {
                                    // Tắt thông báo khi thành công
                                    Swal.close();
                                    setIsRemovingBg(false); // Tắt loading
                                  }

                                  const newImg = new window.Image();
                                  newImg.src = url;
                                  newImg.onload = () => {
                                    setUploadedImages((prev) =>
                                      prev.map((img) =>
                                        img.id === sel.id
                                          ? {
                                              ...img,
                                              image: newImg,
                                              width: sel.width ?? newImg.width,
                                              height: sel.height ?? newImg.height,
                                            }
                                          : img
                                      )
                                    );
                                  };
                                }}
                              >
                                <ContentCut sx={{ fontSize: { xs: 14, sm: 18 } }} />
                              </Button>
                            </Tooltip>
                            <Tooltip title="Lật hình">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  p: "4px",
                                  border: "none !important",
                                  "& .MuiTouchRipple-root": { width: 44, height: 44 },
                                }}
                                onClick={async () => {
                                  increaseActionCount();

                                  const target = uploadedImages.find(
                                    (img) => img.id === selectedImageId
                                  );
                                  if (!target || !target.image) return;

                                  const flippedImage = await flipImageHorizontally(target.image);

                                  setUploadedImages((prev) =>
                                    prev.map((img) =>
                                      img.id === selectedImageId
                                        ? {
                                            ...img,
                                            image: flippedImage,
                                            flipped: !img.flipped, // chỉ để đánh dấu
                                          }
                                        : img
                                    )
                                  );

                                  saveCurrentCanvasState(); // đảm bảo canvasStates cập nhật
                                }}
                              >
                                <Flip sx={{ fontSize: { xs: 14, sm: 18 } }} />
                              </Button>
                            </Tooltip>
                            <Tooltip title="Xóa">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  p: "4px",
                                  border: "none !important",
                                  "& .MuiTouchRipple-root": { width: 44, height: 44 },
                                }}
                                onClick={() => {
                                  setUploadedImages((prev) =>
                                    prev.filter((img) => img.id !== selectedImageId)
                                  );
                                  setSelectedImageId(null);
                                }}
                              >
                                <Delete sx={{ fontSize: { xs: 14, sm: 18 } }} />
                              </Button>
                            </Tooltip>
                          </Box>
                        );
                      })()}

                    {selectedStickerId &&
                      (() => {
                        const konvaNode = stageRef.current?.findOne(`#${selectedStickerId}`);
                        const containerBox = canvasContainerRef.current?.getBoundingClientRect();
                        if (!konvaNode || !containerBox) return null;

                        const rect = konvaNode.getClientRect({ relativeTo: stageRef.current });
                        const top = rect.y + rect.height + 25;
                        const left = rect.x;

                        return (
                          <Box
                            sx={{
                              position: "absolute",
                              top: `${top}px`,
                              left: `${left}px`,
                              zIndex: 1000,
                              display: "flex",
                              background: "#fff",
                              boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                            }}
                          >
                            <Tooltip title="Lật hình">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{ minWidth: 32, p: "4px", border: "none !important" }}
                                onClick={async () => {
                                  increaseActionCount();
                                  pushUndoSnapshot();

                                  const target = stickers.find((s) => s.id === selectedStickerId);
                                  if (!target || !target.image) return;

                                  const flipped = await flipImageHorizontally(target.image);

                                  setStickers((prev) =>
                                    prev.map((s) =>
                                      s.id === selectedStickerId
                                        ? {
                                            ...s,
                                            image: flipped,
                                            flipped: !s.flipped, // chỉ là flag đánh dấu
                                          }
                                        : s
                                    )
                                  );

                                  saveCurrentCanvasState();
                                }}
                              >
                                <Flip sx={{ fontSize: 18 }} />
                              </Button>
                            </Tooltip>

                            <Tooltip title="Xóa">
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{ minWidth: 32, p: "4px", border: "none !important" }}
                                onClick={() => {
                                  setStickers((prev) =>
                                    prev.filter((img) => img.id !== selectedStickerId)
                                  );
                                  setSelectedStickerId(null);
                                }}
                              >
                                <Delete sx={{ fontSize: 18 }} />
                              </Button>
                            </Tooltip>
                          </Box>
                        );
                      })()}

                    {showCropModal && imageToCrop && (
                      <CropModal
                        imageSrc={imageToCrop}
                        onCropComplete={(croppedDataUrl) => {
                          pushUndoSnapshot();

                          const newImg = new window.Image();
                          newImg.onload = () => {
                            const width = newImg.naturalWidth;
                            const height = newImg.naturalHeight;

                            // Optional: căn giữa nếu muốn
                            const canvasWidthC = stageRef.current?.width() || 500;
                            const canvasHeightC = stageRef.current?.height() || 500;
                            const x = canvasWidthC / 2 - width / 2;
                            const y = canvasHeightC / 2 - height / 2;

                            setUploadedImages((prev) =>
                              prev.map((img) =>
                                img.id === selectedImageId
                                  ? {
                                      ...img,
                                      image: newImg,
                                      width,
                                      height,
                                      x, // cập nhật vị trí nếu cần
                                      y,
                                    }
                                  : img
                              )
                            );
                          };
                          newImg.src = croppedDataUrl;
                        }}
                        onClose={() => setShowCropModal(false)}
                      />
                    )}
                  </Box>

                  <LayerNavigator
                    layers={filteredLayerOptions.map((l) => ({
                      id: l.layerId,
                      label: l.layerName,
                    }))}
                    selectedId={selectedLayerId}
                    onSelect={(id) => {
                      if (id === selectedLayerId) {
                        setSelectedLayerId(null); // 👈 Bỏ chọn nếu click lại chính nó
                      } else {
                        setSelectedLayerId(id);
                      }
                    }}
                    visibleCount={3}
                  />

                  {(() => {
                    const layersOnFace = filteredLayerOptions;
                    const layerToColor =
                      selectedLayerId != null
                        ? layersOnFace.find((l) => l.layerId === selectedLayerId)
                        : layersOnFace.find((l) => l.isColorChange === 1); // ✅ fallback nếu chưa chọn

                    if (!layerToColor || layerToColor.isColorChange !== 1) return null;

                    return (
                      <Box ref={colorPickerRef} sx={{ position: "relative", mt: 2 }}>
                        <Box ref={colorPickerRef} sx={{ position: "relative", mt: 2 }}>
                          <Box display="flex" alignItems="center" gap={{ xs: 0.5, sm: 2 }}>
                            {/* Nút đổi màu RGB mở ChromePicker */}
                            <Box
                              ref={colorButtonRef}
                              onClick={(e) => {
                                const rect = e.currentTarget.getBoundingClientRect();
                                setColorPickerPosition({
                                  top: -240,
                                  left:
                                    rect.left -
                                    e.currentTarget.offsetParent.getBoundingClientRect().left,
                                });
                                increaseActionCount();
                                setShowColorPicker(!showColorPicker);
                              }}
                              sx={{
                                mx: 2,
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                background:
                                  "conic-gradient(red, yellow, lime, aqua, blue, magenta, red)",
                                cursor: "pointer",
                                boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
                              }}
                            />

                            {/* Preset colors */}
                            {["#4AC665", "#4285F4", "#480E73", "#FF5601"].map((color) => (
                              <Box
                                key={color}
                                onClick={() => {
                                  increaseActionCount();
                                  applyColorToSelectedLayer(color); // Không set textColor
                                }}
                                sx={{
                                  mx: 2,
                                  width: 32,
                                  height: 32,
                                  borderRadius: "50%",
                                  backgroundColor: color,
                                  cursor: "pointer",
                                  boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
                                }}
                              />
                            ))}
                          </Box>

                          {showColorPicker && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: `${colorPickerPosition.top}px`,
                                left: `${colorPickerPosition.left}px`,
                                zIndex: 999,
                              }}
                              ref={canvasColorPickerRef}
                            >
                              <ChromePicker
                                color={
                                  layerColorMap[`${currentAttachType}-${selectedLayerId}`] ||
                                  "#000000"
                                }
                                onChange={(color) => {
                                  const newColor = color.hex;
                                  applyColorToSelectedLayer(newColor);
                                }}
                                disableAlpha
                              />
                            </Box>
                          )}
                        </Box>

                        {showColorPicker && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: `${colorPickerPosition.top}px`,
                              left: `${colorPickerPosition.left}px`,
                              zIndex: 999,
                            }}
                            ref={canvasColorPickerRef}
                          >
                            <ChromePicker
                              color={textColor}
                              onChange={(color) => {
                                const newColor = color.hex;
                                setTextColor(newColor);
                                applyColorToSelectedLayer(newColor);
                              }}
                              disableAlpha
                            />
                          </Box>
                        )}
                      </Box>
                    );
                  })()}
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
      <PreviewModal
        open={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        previews={previewImages}
      />
      <SharePopup
        open={showShareDialog}
        onClose={() => setShowShareDialog(false)}
        link={shareLink}
      />

      <input
        type="file"
        accept="image/*"
        multiple
        hidden
        ref={uploadInputRef}
        onChange={(e) => {
          increaseActionCount();
          const files = Array.from(e.target.files);

          const currentCanvasWidth = stageRef.current?.width() || 500;
          const currentCanvasHeight = stageRef.current?.height() || 500;

          files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
              const imageObj = new window.Image();
              imageObj.onload = () => {
                const id = `upload-${Date.now()}-${Math.random()}`;
                const baseScale = Math.min(
                  canvasWidth / imageObj.width,
                  canvasHeight / imageObj.height,
                  1
                );
                const scale = isMobile ? baseScale * 0.5 : baseScale;

                const width = imageObj.width * scale;
                const height = imageObj.height * scale;
                const x = currentCanvasWidth / 2 - width / 2;
                const y = currentCanvasHeight / 2 - height / 2;

                setUploadedImages((prev) => [
                  ...prev,
                  {
                    id,
                    image: imageObj,
                    x,
                    y,
                    width,
                    height,
                    layerKey: `${currentAttachType}-${selectedLayerId}`,
                    flipX: false,
                    attachType: currentAttachType,
                  },
                ]);
              };
              imageObj.src = reader.result;
            };
            reader.readAsDataURL(file);
          });

          e.target.value = "";
        }}
      />

      <Backdrop
        open={isSaving}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1000,
          backdropFilter: "blur(3px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" sx={{ mb: 2 }} />
        <Typography
          variant="h6"
          fontWeight="600"
          textAlign="center"
          color="#ffffff"
          sx={{ textShadow: "0 1px 3px rgba(0,0,0,0.8)" }}
        >
          Đang lưu thiết kế...
          <br />
          Vui lòng không đóng trình duyệt
        </Typography>
      </Backdrop>
      <Backdrop
        open={isRestoringEdit}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 999,
          backdropFilter: "blur(3px)",
          backgroundColor: "rgba(0,0,0,0.4)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" sx={{ mb: 2 }} />
        <Typography color="white" fontWeight={500} textAlign="center">
          Đang tải lại thiết kế để chỉnh sửa...
          <br />
          Vui lòng chờ trong giây lát
        </Typography>
      </Backdrop>
      <Backdrop
        open={isGeneratingPreview}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 998,
          backdropFilter: "blur(3px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" sx={{ mb: 2 }} />
        <Typography variant="h6" fontWeight="600" color="#fff">
          Đang tạo ảnh xem trước...
        </Typography>
      </Backdrop>
      <Backdrop sx={{ color: "#fff", zIndex: 2000 }} open={isGeneratingOverlay}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Backdrop
        open={isRemovingBg}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default DesignToolSection;
